// This function will grab all input values from a form and return an object
function serialize(form) {
    // console.log(form.elements);
    if (!form || form.nodeName !== "FORM") {
        return;
    }

    var i, j, result = {};
    for (i = form.elements.length - 1; i >= 0; i = i - 1) {
        if (form.elements[i].name === "") {
            continue;
        }

        switch (form.elements[i].nodeName) {
            case 'INPUT':
                switch (form.elements[i].type) {
                    case 'text':
                    case 'hidden':
                    case 'password':
                    case 'button':
                    case 'reset':
                    case 'submit':
                        result[form.elements[i].name] = form.elements[i].value.trim();
                        break;
                    case 'radio':
                        if (form.elements[i].checked) {
                            result[form.elements[i].name] = form.elements[i].value;
                        }
                        break;
                    case 'checkbox':
                        let checkboxes = document.querySelectorAll(`input[type="checkbox"][name="${form.elements[i].name}"]`);
                        if (checkboxes.length > 1) {
                            result[form.elements[i].name] = getCheckboxValues(form, form.elements[i].name);
                        } else {
                            result[form.elements[i].name] = form.elements[i].checked;
                        }
                        break;
                    default:
                        result[form.elements[i].name] = form.elements[i].value;
                        break;
                }
                break;
            case 'file':
                break;
            case 'SELECT':
                switch (form.elements[i].type) {
                    case 'select-one':
                        result[form.elements[i].name] = form.elements[i].value;
                        break;
                    case 'select-multiple':
                        for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
                            if (form.elements[i].options[j].selected) {
                                result[form.elements[i].name] = form.elements[i].options[j].value;
                            }
                        }
                        break;
                }
            default:
                result[form.elements[i].name] = form.elements[i].value;
                break;

        }
    }
    return result;
}

function clearForm(form) {
    // Get all input elements within the form
    var inputs = form.getElementsByTagName("input");

    // Loop through each input element
    for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        var type = input.type.toLowerCase();

        // Check the type of input and clear its value accordingly
        switch (type) {
            case "text":
            case "email":
            case "password":
                input.value = "";
                break;
            case "checkbox":
            case "radio":
                input.checked = false;
                break;
            // Add more cases for other input types as needed
        }
    }
}

function validateForm(form) {
  var inputs = form.querySelectorAll('input, select, textarea');
  var isChecked = false;
  var emptyFields = [];

  var checkboxNames = {}; // Keep track of checked checkboxes by name

  for (var i = 0; i < inputs.length; i++) {
    var input = inputs[i];

    // Skip the submit button
    if (input.type === 'submit') {
      continue;
    }

    // Check if the input is not a checkbox and is empty
    if (input.type !== 'checkbox' && input.type !== 'radio' && input.value.trim() === '' && input.hasAttribute('is-required')) {
      var label = document.querySelector(`label[for="${input.id}"]`);
      var fieldName = label ? label.textContent.trim() : input.name;
      emptyFields.push(fieldName + ' is required.');
    } else if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked && input.hasAttribute('is-required')) {
      var checkboxLabel = document.querySelector(`label[for="${input.id}"]`);
      var fieldName = checkboxLabel ? checkboxLabel.textContent.trim() : input.name;

      // Check if there are other checkboxes with the same name that are checked
      var checkboxes = document.querySelectorAll(`input[name="${input.name}"]:checked`);
      if (checkboxes.length === 0) {
        emptyFields.push(fieldName + ' is required.');
      }
    }
  }

  return emptyFields;
}

function scrollToElement(elementId) {
  var element = document.getElementById(elementId);

  if (element) {
    // Calculate the element's position relative to the document
    var elementPosition = element.getBoundingClientRect().top + window.scrollY;

    // Calculate the desired scroll position to center the element vertically
    var offset = window.innerHeight / 2;
    var scrollPosition = elementPosition - offset;

    // Scroll to the element's position with the offset
    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth' // Add smooth scrolling effect (optional)
    });
  }
}

// c is the current page
// m is the page count
// pagination(parseInt(data.current_page), parseInt(data.page_count));
function pagination(c, m) {
    var current = c,
        last = m,
        delta = 2,
        left = current - delta,
        right = current + delta + 1,
        range = [],
        rangeWithDots = [],
        l;

    for (var i = 1; i <= last; i++) {
        if (i == 1 || i == last || i >= left && i < right) {
            range.push(i);
        }
    }

    for (var i of range) {
        if (l) {
            if (i - l === 2) {
                rangeWithDots.push(l + 1);
            } else if (i - l !== 1) {
                rangeWithDots.push('...');
            }
        }
        rangeWithDots.push(i);
        l = i;
    }

    return rangeWithDots;
}

// Helper Functions
// loader - text: Shows Loading...
//        - loader: Shows loader...
// color - only works if loader equals to loader
function loading (el, loader, color){
    // Set default values
    loader = typeof loader !== 'undefined' ? loader : 'text';
    color = typeof color !== 'undefined' ? color : 'primary';

    if (loader === 'text') {
        var html = 'Loading...';
        el.innerHTML = html;
    } else {
        var loader = document.createElement('div');
        loader.setAttribute('class', 'spinner-border spinner-border-sm text-' + color);
        loader.setAttribute('role', 'status');

        var loader_span = document.createElement('span');
        loader_span.setAttribute('class', 'visually-hidden');
        loader_span.innerHTML = 'Loading...';
        loader.appendChild(loader_span);

        el.innerHTML = '';
        el.appendChild(loader)
    }
}

function finished_loading (el, label){
    el.innerHTML = label;
}

function fade_out(el, remove){
    // Set default values
    remove = typeof remove !== 'undefined' ? remove : false;

    el.style.opacity = '1';
    el.style.transition = 'opacity 500ms';
    el.style.opacity = '0';
    if(remove) {
        setTimeout(function(){ el.remove(); }, 500);
    }
}

function fade_in(el){
    el.style.transition = 'opacity 500ms';
    el.style.opacity = '1';
    // setTimeout(function(){ fade_out(el); }, 15000);
}

// Inserts an element after an element
function insert_after(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

// Disable entire form
function disable_form(form, disabled) {
    // Set default values
    disabled = typeof disabled !== 'undefined' ? disabled : true;

    var allElements = form.elements;
    for (var i = 0, l = allElements.length; i < l; ++i) {
        // allElements[i].readOnly = true; 
        allElements[i].disabled = disabled;
    }
}

// Get parameters from string
function parse_query_string(query) {
    var vars = query.split("&");
    var query_string = {};
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        // If first entry with this name
        if (typeof query_string[key] === "undefined") {
            query_string[key] = decodeURIComponent(value);
            // If second entry with this name
        } else if (typeof query_string[key] === "string") {
            var arr = [query_string[key], decodeURIComponent(value)];
            query_string[key] = arr;
            // If third or later entry with this name
        } else {
            query_string[key].push(decodeURIComponent(value));
        }
    }
    return query_string;
}

// Check if license is expired
function licenseExpirationCheck(licenseExpMonth, licenseExpYear){
    var result = false;
    var currentMonth = new Date().getMonth() + 1;
    var currentYear = new Date().getFullYear();

    if(licenseExpYear && licenseExpMonth){
        licenseExpYear = parseInt(licenseExpYear, 10);

        // transform month string into number
        var months = {
            'January' : '01',
            'February' : '02',
            'March' : '03',
            'April' : '04',
            'May' : '05',
            'June' : '06',
            'July' : '07',
            'August' : '08',
            'September' : '09',
            'October' : '10',
            'November' : '11',
            'December' : '12'
        }
        licenseExpMonth = months[licenseExpMonth];

        if ( licenseExpYear < currentYear || (licenseExpYear == currentYear && licenseExpMonth < currentMonth) ) {
            // active error message
            document.querySelector('#license-exp-month').classList.add('is-invalid');
            document.querySelector('#license-exp-year').classList.add('is-invalid');
        } else {
            // remove error message
            document.querySelector('#license-exp-month').classList.remove('is-invalid');
            document.querySelector('#license-exp-year').classList.remove('is-invalid');
            result = true;
        }
    }

    return result;
}

function display_status_badge(status, container) {
    var status_badge = document.createElement('span');
    status_badge.setAttribute('class', 'badge rounded-0 text-uppercase py-2 px-3');
    status_badge.innerHTML = status;
    // add appropriate class depending on status
    switch (status) {
        case 'Certified':
            status_badge.classList.add('bg-success');
            break;
        case 'Inactive':
            status_badge.classList.add('bg-danger');
            break;
        default:
            status_badge.classList.add('bg-secondary');
    }
    container.appendChild(status_badge);
}

// Display missing information warning
function display_missing_info_warning(empty_fields_array, container, hide) {
    // Set default values
    hide = typeof hide !== 'undefined' ? hide : false;

    var message_div_current = document.querySelector('#missing-info-alert');
    if(message_div_current){
        fade_out(message_div_current, true);
    }

    if(!hide){
        var message_div = document.createElement('div');
        message_div.setAttribute('id', 'missing-info-alert');
        message_div.setAttribute('class', 'alert alert-warning mt-4');

        var message_div_h5 = document.createElement('h5');
        message_div_h5.setAttribute('class', 'fw-bold');
        message_div_h5.innerHTML = 'MISSING INFORMATION';
        message_div.append(message_div_h5);

        var message_div_p = document.createElement('p');
        message_div_p.setAttribute('class', 'm-0');
        message_div_p.innerHTML = 'Your account has been successfully updated! In order to continue please make sure you fill out the following fields: ';
        message_div_p.innerHTML += '<b>' + empty_fields_array.join(", ") + '</b>';
        message_div.append(message_div_p);

        container.appendChild(message_div);
    }
}

// Display error alert
function hospital_error_alert(empty_fields_array, container, hide) {
    // Set default values
    hide = typeof hide !== 'undefined' ? hide : false;

    var message_div_current = document.querySelector('#missing-info-alert');
    if(message_div_current){
        fade_out(message_div_current, true);
    }

    if(!hide){
        var message_div = document.createElement('div');
        message_div.setAttribute('id', 'missing-info-alert');
        message_div.setAttribute('class', 'alert alert-danger mt-4');

        var message_div_h5 = document.createElement('h5');
        message_div_h5.setAttribute('class', 'fw-bold');
        message_div_h5.innerHTML = 'ERROR UPDATING HOSPITAL';
        message_div.append(message_div_h5);

        var message_div_p = document.createElement('p');
        message_div_p.setAttribute('class', 'm-0');
        message_div_p.innerHTML = 'Error saving hospital address! The following fields are required: ';
        message_div_p.innerHTML += '<b>' + empty_fields_array.join(", ") + '</b>';
        message_div.append(message_div_p);

        container.appendChild(message_div);
    }
}

// Display missing information warning
function display_error_alert(empty_fields_array, container, hide) {
    // Set default values
    hide = typeof hide !== 'undefined' ? hide : false;

    var message_div_current = document.querySelector('#errors-alert');
    if(message_div_current){
        fade_out(message_div_current, true);
    }

    if(!hide){
        var message_div = document.createElement('div');
        message_div.setAttribute('id', 'errors-alert');
        message_div.setAttribute('class', 'alert alert-danger mt-4');

        var message_div_h5 = document.createElement('h5');
        message_div_h5.setAttribute('class', 'fw-bold');
        message_div_h5.innerHTML = 'ERROR UPDATING ACCOUNT';
        message_div.append(message_div_h5);

       for (let index = 0; index < empty_fields_array.length; ++index) {
            const error = empty_fields_array[index];
            var message_div_p = document.createElement('p');
            message_div_p.setAttribute('class', 'm-0');
            message_div_p.innerHTML += '<b>' + error.field + ':</b> ' + error.message;
            message_div.append(message_div_p);
        }

        container.appendChild(message_div);
    }
}

// displays specialties on a table
function display_specialty_table_rows(data, table_body) {
    table_body.innerHTML = '';

    if(data.specialty_option == 'add_specialty') {
        // Logic if we are displaying specialties and subspecialties
        if (data.records.length > 0){
            var specialty_index = 0;
            for(key in data.records){
                var specialty = data.records[key];
                // console.log(specialty, index);
    
                var specialty_table_body_tr = document.createElement('tr');
                specialty_table_body_tr.setAttribute('class', 'specialty_' + specialty_index);
                table_body.appendChild(specialty_table_body_tr);
    
                var specialty_table_td_1 = document.createElement('td');
                specialty_table_body_tr.appendChild(specialty_table_td_1);
    
                if(specialty.subspecialties){
                    var specialty_table_expand = document.createElement('button');
                    specialty_table_expand.setAttribute('class', 'btn btn-primary btn-sm specialty-collapse');
                    specialty_table_expand.setAttribute('type', 'button');
                    specialty_table_expand.setAttribute('data-bs-toggle', 'collapse');
                    specialty_table_expand.setAttribute('data-bs-target', '.subspecialties_' + specialty_index);
                    specialty_table_expand.innerHTML = '-';
                    specialty_table_td_1.appendChild(specialty_table_expand);
                }
    
                var specialty_table_td_2 = document.createElement('td');
                specialty_table_td_2.innerHTML = specialty.name;
                specialty_table_body_tr.appendChild(specialty_table_td_2);
    
                var specialty_table_td_3 = document.createElement('td');
                specialty_table_body_tr.appendChild(specialty_table_td_3);
                
                if (data.specialty_option == 'add_specialty') {
                    var specialty_table_form = document.createElement('form');
                    var specialty_table_form_id = (specialty.added) ? 'remove_specialty' : 'add_specialty';
                    specialty_table_form.setAttribute('id', specialty_table_form_id);
                    specialty_table_form.setAttribute('class', 'd-flex justify-content-end');
                    specialty_table_td_3.appendChild(specialty_table_form);
            
                    var specialty_form_input_2 = document.createElement('input');
                    specialty_form_input_2.setAttribute('type', 'hidden');
                    var specialty_form_input_2_name = 'specialty_name';
                    specialty_form_input_2.setAttribute('name', specialty_form_input_2_name);
                    specialty_form_input_2.setAttribute('id', specialty_form_input_2_name);
                    specialty_form_input_2.setAttribute('value', specialty.name);
                    specialty_table_form.appendChild(specialty_form_input_2);
            
                    var specialty_form_input_3 = document.createElement('input');
                    specialty_form_input_3.setAttribute('type', 'hidden');
                    var specialty_form_input_3_name = 'specialty_id';
                    specialty_form_input_3.setAttribute('name', specialty_form_input_3_name);
                    specialty_form_input_3.setAttribute('id', specialty_form_input_3_name);
                    specialty_form_input_3.setAttribute('value', specialty.id);
                    specialty_table_form.appendChild(specialty_form_input_3);
    
                    var specialty_form_input_4 = document.createElement('input');
                    specialty_form_input_4.setAttribute('type', 'hidden');
                    specialty_form_input_4.setAttribute('name', 'specialty_type');
                    specialty_form_input_4.setAttribute('id', 'specialty_type');
                    specialty_form_input_4.setAttribute('value', data.specialty_type);
                    specialty_table_form.appendChild(specialty_form_input_4);
            
                    if(specialty.hasOwnProperty('opportunity_id')){
                        var specialty_form_input_5 = document.createElement('input');
                        specialty_form_input_5.setAttribute('type', 'hidden');
                        var specialty_form_input_5_name = 'specialty_opportunity_id';
                        specialty_form_input_5.setAttribute('name', specialty_form_input_5_name);
                        specialty_form_input_5.setAttribute('id', specialty_form_input_5_name);
                        specialty_form_input_5.setAttribute('value', specialty.opportunity_id);
                        specialty_table_form.appendChild(specialty_form_input_5);
                    }
            
                    var specialty_form_submit = document.createElement('button');
                    specialty_form_submit.setAttribute('type', 'submit');
                    specialty_form_submit.setAttribute('data-specialty-index', specialty_index);
                    var specialty_form_submit_classes = (specialty.added) ? 'btn btn-outline-danger btn-sm' : 'btn btn-outline-info btn-sm';
                    specialty_form_submit.setAttribute('class', specialty_form_submit_classes);
                    specialty_form_submit.innerHTML = (specialty.added) ? 'Remove' : 'Add';
                    specialty_table_form.appendChild(specialty_form_submit);
                }
    
                // Add subspecialty rows
                if(specialty.subspecialties){
                    display_subspecialty_table_rows(specialty.subspecialties, specialty.opportunity_id, specialty_index, specialty_table_body_tr);
                }

                specialty_index ++;
            };
        } else {
            var specialty_table_body_tr = document.createElement('tr');
            table_body.appendChild(specialty_table_body_tr);
    
            var specialty_table_td_1 = document.createElement('td');
            specialty_table_td_1.setAttribute('colspan', '2');
            specialty_table_td_1.innerHTML = 'No items match your search result';
            specialty_table_body_tr.appendChild(specialty_table_td_1);
        }
    } else {
        // Logic if we are displaying subspecialties
        var count = 0;
        for(key in data.records){
            if (data.records.hasOwnProperty(key)) {
                var specialty_table_body_tr = document.createElement('tr');
                specialty_table_body_tr.setAttribute('class', 'specialty_' + count);
                table_body.appendChild(specialty_table_body_tr);
    
                var specialty_table_td_1 = document.createElement('td');
                specialty_table_body_tr.appendChild(specialty_table_td_1);
    
                var specialty_table_expand = document.createElement('button');
                specialty_table_expand.setAttribute('class', 'btn btn-primary btn-sm specialty-collapse');
                specialty_table_expand.setAttribute('type', 'button');
                specialty_table_expand.setAttribute('data-bs-toggle', 'collapse');
                specialty_table_expand.setAttribute('data-bs-target', '.subspecialties_' + count);
                specialty_table_expand.innerHTML = '-';
                specialty_table_td_1.appendChild(specialty_table_expand);
    
                var specialty_table_td_2 = document.createElement('td');
                specialty_table_td_2.innerHTML = key;
                specialty_table_body_tr.appendChild(specialty_table_td_2);
    
                var specialty_table_td_3 = document.createElement('td');
                specialty_table_body_tr.appendChild(specialty_table_td_3);

                display_subspecialty_table_rows(data.records[key], null, count, specialty_table_body_tr);
            }

            count ++;
        };
    }
}

function display_subspecialty_table_rows(subspecialties, specialty_opportunity_id, specialty_index, specialty_row) {
    if(subspecialties.length > 0){
        for(key in subspecialties){
            var subspecialty = subspecialties[key];
            var subspecialty_table_body_tr = document.createElement('tr');
            subspecialty_table_body_tr.setAttribute('class', 'collapse show subspecialties_' + specialty_index);
            insert_after(subspecialty_table_body_tr, specialty_row);

            var specialty_table_td_1 = document.createElement('td');
            subspecialty_table_body_tr.appendChild(specialty_table_td_1);

            var subspecialty_table_td = document.createElement('td');
            subspecialty_table_td.setAttribute('class', 'text-muted');
            subspecialty_table_td.innerHTML = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + subspecialty.name;
            subspecialty_table_body_tr.appendChild(subspecialty_table_td);

            var subspecialty_table_td_3 = document.createElement('td');
            subspecialty_table_body_tr.appendChild(subspecialty_table_td_3);

            var subspecialty_table_form = document.createElement('form');
            var subspecialty_table_form_id = (subspecialty.added) ? 'remove_subspecialty' : 'add_subspecialty';
            subspecialty_table_form.setAttribute('id', subspecialty_table_form_id);
            subspecialty_table_form.setAttribute('class', 'd-flex justify-content-end');
            subspecialty_table_td_3.appendChild(subspecialty_table_form);

            // Subspecialty Name
            // This input is used to name the subspecialty opportunity
            var subspecialty_form_input_1 = document.createElement('input');
            subspecialty_form_input_1.setAttribute('type', 'hidden');
            var subspecialty_form_input_1_name = 'subspecialty_name' ;
            subspecialty_form_input_1.setAttribute('name', subspecialty_form_input_1_name);
            subspecialty_form_input_1.setAttribute('id', subspecialty_form_input_1_name);
            subspecialty_form_input_1.setAttribute('value', subspecialty.name);
            subspecialty_table_form.appendChild(subspecialty_form_input_1);
            
            // Subspecialty ID
            // This is used to add the right subspecialty to the opportunity.
            var subspecialty_form_input_2 = document.createElement('input');
            subspecialty_form_input_2.setAttribute('type', 'hidden');
            var subspecialty_form_input_2_name = 'subspecialty_id';
            subspecialty_form_input_2.setAttribute('name', subspecialty_form_input_2_name);
            subspecialty_form_input_2.setAttribute('id', subspecialty_form_input_2_name);
            subspecialty_form_input_2.setAttribute('value', subspecialty.id);
            subspecialty_table_form.appendChild(subspecialty_form_input_2);

            // Only add if we are adding specialties and subspecialties
            // This value is used when adding a subspecialty with specialty
            if(specialty_opportunity_id){
                var subspecialty_form_input_3 = document.createElement('input');
                subspecialty_form_input_3.setAttribute('type', 'hidden');
                var subspecialty_form_input_3_name = 'specialty_opportunity_id';
                subspecialty_form_input_3.setAttribute('name', subspecialty_form_input_3_name);
                subspecialty_form_input_3.setAttribute('id', subspecialty_form_input_3_name);
                subspecialty_form_input_3.setAttribute('value', specialty_opportunity_id);
                subspecialty_table_form.appendChild(subspecialty_form_input_3);
            }

            // Only add if we are adding only subspecialties
            // This value is used when adding a subspecialty only
            if(subspecialty.hasOwnProperty('opportunity_category')){
                var subspecialty_form_input_4 = document.createElement('input');
                subspecialty_form_input_4.setAttribute('type', 'hidden');
                var subspecialty_form_input_4_name = 'subspecialty_opportunity_category';
                subspecialty_form_input_4.setAttribute('name', subspecialty_form_input_4_name);
                subspecialty_form_input_4.setAttribute('id', subspecialty_form_input_4_name);
                subspecialty_form_input_4.setAttribute('value', subspecialty.opportunity_category);
                subspecialty_table_form.appendChild(subspecialty_form_input_4);
            }
            
            // Only add if we are adding only subspecialties
            // This value is used to know which specialty to relate to
            // when adding a subspecialty only
            if(subspecialty.hasOwnProperty('specialty_id')){
                var subspecialty_form_input_5 = document.createElement('input');
                subspecialty_form_input_5.setAttribute('type', 'hidden');
                var subspecialty_form_input_5_name = 'specialty_id';
                subspecialty_form_input_5.setAttribute('name', subspecialty_form_input_5_name);
                subspecialty_form_input_5.setAttribute('id', subspecialty_form_input_5_name);
                subspecialty_form_input_5.setAttribute('value', subspecialty.specialty_id);
                subspecialty_table_form.appendChild(subspecialty_form_input_5);
            }

            // Only add if the specialty or subspecialty is added.
            // This is used to remove a specialty or subspecialty
            if(subspecialty.hasOwnProperty('opportunity_id')){
                var subspecialty_form_input_6 = document.createElement('input');
                subspecialty_form_input_6.setAttribute('type', 'hidden');
                var subspecialty_form_input_6_name = 'subspecialty_opportunity_id';
                subspecialty_form_input_6.setAttribute('name', subspecialty_form_input_6_name);
                subspecialty_form_input_6.setAttribute('id', subspecialty_form_input_6_name);
                subspecialty_form_input_6.setAttribute('value', subspecialty.opportunity_id);
                subspecialty_table_form.appendChild(subspecialty_form_input_6);
            }
    
            var subspecialty_form_submit = document.createElement('button');
            subspecialty_form_submit.setAttribute('type', 'submit');
            var subspecialty_form_submit_classes = (subspecialty.added) ? 'btn btn-outline-danger btn-sm' : 'btn btn-outline-info btn-sm';
            subspecialty_form_submit.setAttribute('class', subspecialty_form_submit_classes);
            subspecialty_form_submit.innerHTML = (subspecialty.added) ? 'Remove' : 'Add';
            subspecialty_table_form.appendChild(subspecialty_form_submit);
        }
    } else {
        var subspecialty_table_body_tr = document.createElement('tr');
        subspecialty_table_body_tr.setAttribute('class', 'collapse subspecialties_' + specialty_index);
        insert_after(subspecialty_table_body_tr, specialty_row);

        var subspecialty_table_td_1 = document.createElement('td');
        subspecialty_table_body_tr.appendChild(subspecialty_table_td_1);

        var subspecialty_table_td_2 = document.createElement('td');
        subspecialty_table_td_2.setAttribute('class', 'text-muted');
        subspecialty_table_td_2.setAttribute('colspan', '2');
        subspecialty_table_td_2.innerHTML = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp No subspecialties offered.';
        subspecialty_table_body_tr.appendChild(subspecialty_table_td_2);
    }
}

function display_contact_opportunities() {
    var nbpas_application = document.querySelector('#nbpas_application_review');
    if(nbpas_application){
        var salesforce_id = nbpas_application.getAttribute('data-sf-id');

        var user_data = {};
        user_data['salesforce_id'] = salesforce_id;
        // console.log(user_data);

        // Add loading spinner while we get opportunities
        nbpas_application.innerHTML = '';
        var spinner = document.createElement('div');
        spinner.setAttribute('class', 'spinner-border text-dark my-4');
        spinner.setAttribute('role', 'status');
        nbpas_application.appendChild(spinner);

        var spinner_span = document.createElement('span');
        spinner_span.setAttribute('class', 'visually-hidden');
        spinner_span.innerHTML = 'Loading...';
        spinner.appendChild(spinner_span);

        user_data = JSON.stringify(user_data);
        var request = new Request('https://app.nbpas.org/api_endpoints/get_contact_opportunities.php', {
            method: 'POST',
            body: user_data,
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            console.log(data);

            nbpas_application.innerHTML = '';
            var specialty_row = document.createElement('div');
            specialty_row.setAttribute('class', 'row flex-column');
            nbpas_application.appendChild(specialty_row);

            // Check if user has an opportunity
            if(data.success){
                // Display contact opportunities
                if(data.specialties.length > 0 || data.subspecialties.length > 0){
                    if(data.specialties.length > 0) {
                        for (key in data.specialties){
                            var specialty = data.specialties[key];
                            // console.log(specialty);
            
                            var specialty_col = document.createElement('div');
                            specialty_col.setAttribute('class', 'col-12 col-lg-8 col-xl-6 my-3');
                            specialty_row.appendChild(specialty_col);
            
                            var specialty_card = document.createElement('div');
                            specialty_card.setAttribute('class', 'card');
                            specialty_col.appendChild(specialty_card);
            
                            var specialty_card_body = document.createElement('div');
                            specialty_card_body.setAttribute('class', 'card-body bg-light');
                            specialty_card.appendChild(specialty_card_body);
            
                            var specialty_card_title = document.createElement('h5');
                            specialty_card_title.setAttribute('class', 'card-title');
                            specialty_card_title.innerHTML = specialty.name;
                            specialty_card_body.appendChild(specialty_card_title);

                            if(specialty.need_hospital_privileges) {
                                var nhp_span = document.createElement('span');
                                nhp_span.setAttribute('class', 'ms-2');
                                nhp_span.setAttribute('data-bs-toggle', 'tooltip');
                                nhp_span.setAttribute('data-bs-placement', 'top');
                                nhp_span.setAttribute('data-bs-title', 'Need Hospital Privileges');
                                specialty_card_title.appendChild(nhp_span);

                                var nhp_icon = document.createElement('i');
                                nhp_icon.setAttribute('class', 'bi bi-hospital text-primary fs-6');
                                nhp_span.appendChild(nhp_icon);
                            }

                            var specialty_card_subtitle = document.createElement('h6');
                            specialty_card_subtitle.setAttribute('class', 'card-subtitle text-muted');
                            specialty_card_subtitle.innerHTML = specialty.board + ' Specialty';
                            specialty_card_body.appendChild(specialty_card_subtitle);
            
                            if(specialty.hasOwnProperty('subspecialties') && specialty.subspecialties.length > 0) {
                                var specialty_card_hr = document.createElement('hr');
                                specialty_card_body.appendChild(specialty_card_hr);
            
                                var specialty_card_p = document.createElement('p');
                                specialty_card_p.setAttribute('class', 'fw-bold mb-0');
                                specialty_card_p.innerHTML = 'Subspecialties'
                                specialty_card_body.appendChild(specialty_card_p);
            
                                var specialty_card_div = document.createElement('div');
                                specialty_card_div.setAttribute('class', 'd-flex flex-column');
                                specialty_card_body.appendChild(specialty_card_div);

                                for (key in specialty.subspecialties){
                                    var subspecialty = specialty.subspecialties[key];
                                  
                                    var specialty_card_sub = document.createElement('p');
                                    specialty_card_sub.setAttribute('class', 'mb-0');
                                    specialty_card_sub.innerHTML = subspecialty.name;

                                    if(subspecialty.need_hospital_privileges) {
                                      var nhp_span = document.createElement('span');
                                      nhp_span.setAttribute('class', 'ms-2');
                                      nhp_span.setAttribute('data-bs-toggle', 'tooltip');
                                      nhp_span.setAttribute('data-bs-placement', 'top');
                                      nhp_span.setAttribute('data-bs-title', 'Need Hospital Privileges');
                                      specialty_card_sub.appendChild(nhp_span);
      
                                      var nhp_icon = document.createElement('i');
                                      nhp_icon.setAttribute('class', 'bi bi-hospital text-primary fs-6');
                                      nhp_span.appendChild(nhp_icon);
                                    }

                                    specialty_card_div.appendChild(specialty_card_sub);
                                }
                            }
                        }
                    }
            
                    if(data.subspecialties.length > 0) {
                        for (key in data.subspecialties){
                            var subspecialty = data.subspecialties[key];
                            // console.log(subspecialty);
            
                            var subspecialty_col = document.createElement('div');
                            subspecialty_col.setAttribute('class', 'col-12 col-lg-8 col-xl-6 my-3');
                            specialty_row.appendChild(subspecialty_col);
            
                            var subspecialty_card = document.createElement('div');
                            subspecialty_card.setAttribute('class', 'card');
                            subspecialty_col.appendChild(subspecialty_card);
            
                            var subspecialty_card_body = document.createElement('div');
                            subspecialty_card_body.setAttribute('class', 'card-body bg-light');
                            subspecialty_card.appendChild(subspecialty_card_body);
            
                            var subspecialty_card_title = document.createElement('h5');
                            subspecialty_card_title.setAttribute('class', 'card-title');
                            subspecialty_card_title.innerHTML = subspecialty.name;
                            subspecialty_card_body.appendChild(subspecialty_card_title);

                            if(subspecialty.need_hospital_privileges) {
                              var nhp_span = document.createElement('span');
                              nhp_span.setAttribute('class', 'ms-2');
                              nhp_span.setAttribute('data-bs-toggle', 'tooltip');
                              nhp_span.setAttribute('data-bs-placement', 'top');
                              nhp_span.setAttribute('data-bs-title', 'Need Hospital Privileges');
                              subspecialty_card_title.appendChild(nhp_span);

                              var nhp_icon = document.createElement('i');
                              nhp_icon.setAttribute('class', 'bi bi-hospital text-primary fs-6');
                              nhp_span.appendChild(nhp_icon);
                            }

                            var subspecialty_card_subtitle = document.createElement('h6');
                            subspecialty_card_subtitle.setAttribute('class', 'card-subtitle text-muted');
                            subspecialty_card_subtitle.innerHTML = subspecialty.type + ' Subspecialty';
                            subspecialty_card_body.appendChild(subspecialty_card_subtitle);
                        }
                    }
            
                    var hospital_privileges = document.querySelector('#hospital_privileges');
                    var continue_application_btn = document.querySelector('#continue_application');
                    var checkout_btn = document.querySelector('#checkout');
                    if(hospital_privileges){
                        if(data.need_hospital_privileges){
                            var hospital_name = document.querySelector('#hospital_name');
                            var hospital_street = document.querySelector('#hospital_street');
                            var hospital_city = document.querySelector('#hospital_city');
                            var hospital_state = document.querySelector('#hospital_state');
                            var hospital_zip = document.querySelector('#hospital_zip');

                            var hospital_address = data.hospital_address;
                            if(hospital_address.length !== 0){
                                if(hospital_address.name){
                                  hospital_name.value = hospital_address.name;
                                }

                                if(hospital_address.street){
                                  hospital_street.value = hospital_address.street;
                                }
  
                                if(hospital_address.city){
                                  hospital_city.value = hospital_address.city;
                                }
  
                                if(hospital_address.state){
                                  hospital_state.value = hospital_address.state;
                                }
  
                                if(hospital_address.zip){
                                  hospital_zip.value = hospital_address.zip;
                                }
                            }
                          
                            hospital_privileges.classList.remove('d-none');

                            if(continue_application_btn){
                              if(!continue_application_btn.disabled) {
                                  continue_application_btn.disabled = true;
                              }
                            }

                            if(checkout_btn){
                              if(!checkout_btn.disabled) {
                                  checkout_btn.disabled = true;
                              }
                            }
                        } else {
                            hospital_privileges.classList.add('d-none');

                            // If no hospital privilege is needed
                            // enable continue button
                            if(nbpas_application.hasAttribute('data-review-page')){
                                if(continue_application_btn){
                                  if(continue_application_btn.disabled) {
                                      continue_application_btn.disabled = false;
                                  }
                                }

                                if(checkout_btn){
                                  if(checkout_btn.disabled) {
                                      checkout_btn.disabled = false;
                                  }
                                }
                            }
                        }
                    }
                } else {
                    // Redirect to verify user info page
                    // only if user is on application review page
                    if(nbpas_application.hasAttribute('data-review-page')){
                        window.location.replace("/pages/application");
                    }

                    var application_msg = document.createElement('div');
                    application_msg.setAttribute('class', 'col-12');
                    specialty_row.appendChild(application_msg);
            
                    var application_msg_p = document.createElement('p');
                    application_msg_p.innerHTML = 'You currently have no specialties nor subspecialties selected.<br>To continue with the application you need to have at least one specialty or subspecialty selected.';
                    application_msg.appendChild(application_msg_p);
                }
            } else {
                // Redirect to verify user info page
                // only it user is on application review page
                if(nbpas_application.hasAttribute('data-review-page')){
                    window.location.replace("/pages/my-applications");
                }
                
                var application_msg = document.createElement('div');
                application_msg.setAttribute('class', 'col-12');
                specialty_row.appendChild(application_msg);

                var application_msg_p = document.createElement('p');
                application_msg_p.innerHTML = 'You currently have no specialties nor subspecialties selected.<br>To continue with the application you need to have at least one specialty or subspecialty selected.';
                application_msg.appendChild(application_msg_p);
            }

            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
        }).catch(function(error) { console.log("Error Getting Opportunity: " + error) });
    }
}

function display_individual_verification(container) {
    if(container){
        var url_string = window.location.search.substring(1);
        var url_parameters = parse_query_string(url_string);
        var opportunity_id = url_parameters.opportunity_id;

        // var url = new URL(url_string);
        // var opportunity_id = url.searchParams.get("opportunity_id");

        var user_data = {};
        user_data['opportunity_id'] = opportunity_id;
        // console.log(user_data);

        // Add loading spinner while we get opportunities
        container.innerHTML = '';
        var spinner = document.createElement('div');
        spinner.setAttribute('class', 'spinner-border text-dark my-4');
        spinner.setAttribute('role', 'status');
        container.appendChild(spinner);

        var spinner_span = document.createElement('span');
        spinner_span.setAttribute('class', 'visually-hidden');
        spinner_span.innerHTML = 'Loading...';
        spinner.appendChild(spinner_span);

        user_data = JSON.stringify(user_data);
        var request = new Request('https://app.nbpas.org/api_endpoints/get_opportunity_by_id.php', {
            method: 'POST',
            body: user_data,
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            console.log(data);
            container.innerHTML = '';

            var verification_card = document.createElement('div');
            verification_card.setAttribute('class', 'card rounded-0 border-0 shadow h-100');
            // verification_card.setAttribute('style', 'max-width: 800px;');
            container.appendChild(verification_card);

            var verification_card_body = document.createElement('div');
            verification_card_body.setAttribute('class', 'card-body p-4 p-md-5');
            verification_card.appendChild(verification_card_body);

            var current_date = document.createElement('p');
            current_date.setAttribute('class', 'text-muted text-uppercase mb-4');
            current_date.innerHTML = data.current_date;
            verification_card_body.appendChild(current_date);

            var contact_name = document.createElement('h3');
            contact_name.setAttribute('class', 'my-4');
            contact_name.innerHTML = data.contact_name;
            verification_card_body.appendChild(contact_name);

            var status = document.createElement('p');
            status.setAttribute('class', 'mb-4 fw-bold');
            status.innerHTML = 'Certification Status: ';
            verification_card_body.appendChild(status);

            display_status_badge(data.status, status);

            var nbpas_id = document.createElement('p');
            nbpas_id.setAttribute('class', 'mb-0');
            nbpas_id.innerHTML = '<span class="fw-bold">NBPAS ID:</span> ' + data.nbpas_id;
            verification_card_body.appendChild(nbpas_id);
          
            if(data.status != 'Pending'){
                if(data.has_in_progress_opportunity === true){
                    var has_in_progress_opportunity = document.createElement('p');
                    has_in_progress_opportunity.setAttribute('class', 'mb-0');
                    has_in_progress_opportunity.innerHTML = '<span class="fw-bold">Recertification Status:</span> In Process';
                    verification_card_body.appendChild(has_in_progress_opportunity);
                }

                if(data.date_first_verified != ''){
                    var initial_certification_date = document.createElement('p');
                    initial_certification_date.setAttribute('class', 'mb-0');
                    initial_certification_date.innerHTML = '<span class="fw-bold">Initial Certification Date:</span> ' + data.date_first_verified;
                    verification_card_body.appendChild(initial_certification_date);
                }
    
                if(data.expiration_date != ''){
                    var certification_expires = document.createElement('p');
                    certification_expires.setAttribute('class', 'mb-0');
                    certification_expires.innerHTML = '<span class="fw-bold">Expiration Date:</span> ' + data.expiration_date;
                    verification_card_body.appendChild(certification_expires);
                }
                
                if(data.status == 'Certified') {
                    if(data.specialties.length > 0) {
                        var specialties_container = document.createElement('div');
                        specialties_container.setAttribute('class', 'mt-4');
                        verification_card_body.appendChild(specialties_container);

                        var specialties = document.createElement('p');
                        specialties.innerHTML = '<span class="fw-bold">Certified in:</span> ';

                        if(data.specialties.length == 1) {
                            specialties.innerHTML += data.specialties[0];
                        } else {
                            var specialties_array = data.specialties.slice();
                            var last_item = specialties_array.pop();
                            specialties.innerHTML += specialties_array.join(', ') + ' and ' + last_item;
                        }

                        specialties_container.appendChild(specialties);
                    }
                }
            }

            // Add print button
            var print_verification_actions = document.createElement('div');
            print_verification_actions.setAttribute('id', 'print_verification_actions');
            verification_card_body.appendChild(print_verification_actions);

            if (data.status == 'Certified') {
                var print_verification_btn_1 = document.createElement('button');
                print_verification_btn_1.setAttribute('class', 'btn btn-primary');
                print_verification_btn_1.setAttribute('onclick', 'download_individual_certification("'+ opportunity_id +'")');
                print_verification_btn_1.innerHTML = 'Download';
                print_verification_actions.appendChild(print_verification_btn_1);
            }

            var print_verification_btn = document.createElement('a');
            print_verification_btn.setAttribute('class', 'btn btn-primary');
            print_verification_btn.setAttribute('href', '/pages/print-certification?opportunity_id=' + opportunity_id);
            print_verification_btn.setAttribute('target', '_blank');
            print_verification_btn.innerHTML = 'Print';
            print_verification_actions.appendChild(print_verification_btn);
        }).catch(function(error) { console.log("Error Getting Opportunity by ID: " + error) });
    }
}

function display_print_verification(container) {
    if(container){
        // Add loading spinner while we get opportunities
        container.innerHTML = '';
        var spinner = document.createElement('div');
        spinner.setAttribute('class', 'spinner-border text-dark mt-5');
        spinner.setAttribute('role', 'status');
        container.appendChild(spinner);

        var spinner_span = document.createElement('span');
        spinner_span.setAttribute('class', 'visually-hidden');
        spinner_span.innerHTML = 'Loading...';
        spinner.appendChild(spinner_span);

        var url_string = window.location.href;
        var url = new URL(url_string);
        var opportunity_id = url.searchParams.get("opportunity_id");

        var user_data = {};
        user_data['opportunity_id'] = opportunity_id;
        // console.log(user_data);

        user_data = JSON.stringify(user_data);
        var request = new Request('https://app.nbpas.org/api_endpoints/get_opportunity_by_id.php', {
            method: 'POST',
            body: user_data,
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            // console.log(data);
            container.innerHTML = '';

            var print_header = document.createElement('div');
            print_header.setAttribute('class', 'd-flex justify-content-center mb-4');
            container.appendChild(print_header);

            var print_header_img = document.createElement('img');
            print_header_img.setAttribute('id', 'logo');
            print_header_img.setAttribute('style', 'max-width: 200px;');
            print_header_img.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0593/5552/9421/files/nbpas_logo_500px.jpg?v=1637970151');
            print_header.appendChild(print_header_img);

            var print_content = document.createElement('div');
            print_content.setAttribute('class', 'text-start');
            container.appendChild(print_content);

            var print_content_p = document.createElement('p');

            print_content_p.innerHTML = data.current_date + '<br><br>';
            print_content_p.innerHTML += 'To whom it may concern:<br><br>';
            print_content_p.innerHTML += 'NBPAS certification details for '+ data.contact_name +' are as follows:<br><br>';

            var cert_detail_list = document.createElement('div');
            cert_detail_list.setAttribute('class', 'ms-4');

            cert_detail_list.innerHTML += '<b>NBPAS ID: </b>' + data.nbpas_id + '<br>';
            cert_detail_list.innerHTML += '<b>Certification Status: </b>' + data.status + '<br>';

            if(data.date_first_verified != ''){
                cert_detail_list.innerHTML += '<b>Initial Certification Date: </b>' + data.date_first_verified + '<br>';
            }

            if(data.expiration_date != ''){
                cert_detail_list.innerHTML += '<b>Certified through: </b>' + data.expiration_date + '<br>';
            }

            if(data.specialties !== undefined && data.specialties.length > 0) {
                cert_detail_list.innerHTML += '<b>Certified in:</b> ';

                if(data.specialties.length == 1) {
                    cert_detail_list.innerHTML += data.specialties[0];
                } else {
                    var specialties_array = data.specialties.slice();
                    var last_item = specialties_array.pop();
                    cert_detail_list.innerHTML += specialties_array.join(', ') + ' and ' + last_item;
                }
                cert_detail_list.innerHTML += '<br><br>';
            }
            print_content_p.appendChild(cert_detail_list);

            print_content_p.innerHTML += 'NBPAS certification criteria requires initial ABMS or AOA board certification, an active unrestricted medical license, and a minimum of 50 hours of ACCME accredited CME every 24 months in their specialty. For more details, visit <a href="https://nbpas.org/criteria" target="_blank">https://nbpas.org/criteria</a>.<br><br>'
            print_content_p.innerHTML += 'NBPAS performs Primary Source Verification of physician education and training credentials in accordance with national accreditation standards for The Joint Commission (TJC), Det Norske Veritas (DNV), the Center for Improvement in Healthcare Quality (CIHQ), the Accreditation Commission for Healthcare (ACHC), the National Committee for Quality Assurance (NCQA) and the Utilization Review Accreditation Commission (URAC).<br><br>'
            print_content_p.innerHTML += 'Should you have any questions, please contact us at info@nbpas.org or (858) 228-4161.<br><br>'
            print_content_p.innerHTML += 'Sincerely,<br><br>';

            var signature = document.createElement('img');
            signature.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0593/5552/9421/files/KS-signature.png');
            signature.setAttribute('style', 'max-width:200px;');
            print_content_p.appendChild(signature);
            
            print_content_p.innerHTML += '<br><br>';
            print_content_p.innerHTML += 'Kerri Sargent<br>';
            print_content_p.innerHTML += 'Director of Operations and Credentialing, NBPAS';

            print_content.appendChild(print_content_p);

            setTimeout(function(){ window.print(); }, 500);
        }).catch(function(error) { console.log("Error Getting Opportunity by ID: " + error) });
    }
}

function display_print_pdf_certificate(container) {
    if(container){
        var url_string = window.location.href;
        var url = new URL(url_string);
        var opportunity_id = url.searchParams.get("opportunity_id");

        var user_data = {};
        user_data['opportunity_id'] = opportunity_id;
        // console.log(user_data);

        // Add loading spinner while we get opportunities
        container.innerHTML = '';
        var spinner = document.createElement('div');
        spinner.setAttribute('class', 'spinner-border text-dark mt-5');
        spinner.setAttribute('role', 'status');
        container.appendChild(spinner);

        var spinner_span = document.createElement('span');
        spinner_span.setAttribute('class', 'visually-hidden');
        spinner_span.innerHTML = 'Loading...';
        spinner.appendChild(spinner_span);

        user_data = JSON.stringify(user_data);
        var request = new Request('https://app.nbpas.org/api_endpoints/get_opportunity_by_id.php', {
            method: 'POST',
            body: user_data,
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            // console.log(data);
            container.innerHTML = '';

            var actions_container = document.createElement('div');
            actions_container.setAttribute('id', 'print_actions');
            actions_container.setAttribute('class', 'no_print my-3');
            container.appendChild(actions_container);

            var document_title = 'NBPAS_' + data.nbpas_id + '_' + data.last_name + '_' + data.start_date;
            var print_btn = document.createElement('button');
            print_btn.setAttribute('onclick', 'print_pdf_certificate("'+data.opportunity_id+'")');
            print_btn.setAttribute('class', 'btn btn-primary');
            print_btn.innerHTML = 'Print';
            actions_container.appendChild(print_btn);

            var download_btn = document.createElement('button');
            download_btn.setAttribute('class', 'btn btn-primary');
            download_btn.setAttribute('onclick', 'download_pdf_certificate("'+data.opportunity_id+'")');
            download_btn.innerHTML = 'Download';
            actions_container.appendChild(download_btn);

            var share_btn = document.createElement('button');
            share_btn.setAttribute('class', 'btn btn-primary');
            share_btn.setAttribute('onclick', 'share_pdf_certificate("' + data.opportunity_id + '")');
            share_btn.innerHTML = 'Share on LinkedIn';
            actions_container.appendChild(share_btn);

            var print_container = document.createElement('div');
            print_container.setAttribute('id', 'pdf_certificate_content');
            print_container.setAttribute('class', 'd-flex flex-column align-items-center fs-5 text-center');
            container.appendChild(print_container);

            if(data.status != 'Certified'){
                var print_p = document.createElement('p');
                print_p.setAttribute('class', 'my-3');
                print_p.innerHTML = 'No Certificate Available. If you have any questions please contact <a href="mailto:info@nbpas.org">info@nbpas.org</a>.';
                print_container.appendChild(print_p);
            } else {
                var print_p = document.createElement('p');
                print_p.setAttribute('class', 'mb-3');
                print_p.innerHTML = 'The';
                print_container.appendChild(print_p);

                var print_title_img = document.createElement('img');
                print_title_img.setAttribute('style', 'max-width: 800px');
                print_title_img.setAttribute('class', 'w-100');
                print_title_img.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0593/5552/9421/files/nbpas-cert-title.jpg');
                print_container.appendChild(print_title_img);

                var print_p_2 = document.createElement('p');
                print_p_2.setAttribute('class', 'mt-3 mb-0');
                print_p_2.innerHTML = 'attests that';
                print_container.appendChild(print_p_2);

                var print_name = document.createElement('p');
                print_name.setAttribute('class', 'cert_name my-2');
                print_name.innerHTML = data.contact_name;
                print_container.appendChild(print_name);

                var print_p_3 = document.createElement('p');
                print_p_3.innerHTML = 'Meets the requirements and standards set forth by the Board and is certified until<br>';
                print_p_3.innerHTML += data.expiration_date + ' as a diplomate of';
                print_container.appendChild(print_p_3);

                var specialties = '';
                if(data.specialties !== undefined && data.specialties.length > 0) {
                    if(data.specialties.length == 1) {
                        specialties = '<span class="text-uppercase">' + data.specialties[0] + '</span>';
                    } else {
                        var specialties_array = data.specialties.slice();
                        var last_item = specialties_array.pop();
                        specialties = '<span class="text-uppercase">' + specialties_array.join(', ') + '</span> and <span class="text-uppercase">' + last_item + '</span>';
                    }
                }

                var print_p_4 = document.createElement('p');
                print_p_4.innerHTML = specialties;
                print_container.appendChild(print_p_4);

                var print_footer_img = document.createElement('img');
                print_footer_img.setAttribute('style', 'max-width: 1000px');
                print_footer_img.setAttribute('class', 'w-100');
                print_footer_img.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0593/5552/9421/files/nbpas-cert-signatures-updated.jpg');
                print_container.appendChild(print_footer_img);

                var print_p_5 = document.createElement('p');
                print_p_5.setAttribute('style', 'margin-top:60px');
                print_p_5.setAttribute('class', 'text-muted w-100 text-end fs-6');
                if(data.date_first_verified){
                    print_p_5.innerHTML = '<span class="me-5">Initial Certification Date: ' + data.date_first_verified + '</span>';
                }
                print_p_5.innerHTML += 'Certificate No. ' + data.nbpas_id;
                print_container.appendChild(print_p_5);

                // setTimeout(function(){
                //     var document_title = 'NBPAS_' + data.nbpas_id + '_' + data.last_name + '_' + data.start_date;
                //     document.title = document_title;
                //     window.print();
                // }, 500);
            }
        }).catch(function(error) { console.log("Error Getting Opportunity by ID: " + error) });
    }
}

// Transform string to title case
function to_title_case(str) {
    return str.replace(
      /\w\S*/g,
      function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
}

// Toggle password field
function toggle_password(element) {
    // Toggle the type attribute using
    // getAttribure() method
    var type = element.previousElementSibling.getAttribute('type') === 'password' ? 'text' : 'password';
    element.previousElementSibling.setAttribute('type', type);

    // Toggle the eye and bi-eye icon
    element.querySelector('i').classList.toggle('bi-eye');
}

// Check if object is empty
function empty_object(obj) {
    for(var prop in obj) {
        if(obj.hasOwnProperty(prop))
            return false;
    }
    return true;
}

function close_modal_by_id(modal_id) {
    // get modal
    const modal = document.getElementById(modal_id);

    // change state like in hidden modal
    modal.classList.remove('show');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('style', 'display: none');

    // get modal backdrop
    const modalBackdrops = document.getElementsByClassName('modal-backdrop');

    // remove opened modal backdrop
    document.body.removeChild(modalBackdrops[0]);
}

function get_browser() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { name: 'IE', version: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR|Edge\/(\d+)/)
        if (tem != null) { return { name: 'Opera', version: tem[1] }; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return {
        name: M[0],
        version: M[1]
    };
}

(function() {
document.addEventListener("DOMContentLoaded", function() {
    var browser = get_browser();
    // console.log(browser);

    // Check if user is using IE
    if (window.document.documentMode) {
        // redirect user to supported browsers page
        window.location = "/pages/supported-browsers";
    }

    if (window.navigator.msPointerEnabled) {
        window.location = "/pages/supported-browsers";
    }

    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }

    const truncate_elements = document.querySelectorAll('.truncate');
    if (truncate_elements){
        truncate_elements.forEach(element => {
            var truncate_size = 120;
            if(element.getAttribute("truncate-size")){
              truncate_size = element.getAttribute("truncate-size");
            }
            var text = element.innerHTML;
            var truncated = text.substring(0, truncate_size) + "...";
            element.innerHTML = truncated;
        });
    }

    // Register Form
    document.body.addEventListener("submit", async function (event) {
        if(event.target.id == "create_customer"){
            event.preventDefault();
            // console.log("submitted!");

            // Remove any current error messages
            var error_msg_alert = document.querySelector('#error-msg-alert');
            if(error_msg_alert){ fade_out(error_msg_alert, true); }

            var form = event.target;
            // console.log(form.elements);

            var user_data = serialize(form);
            user_data['source'] = get_cookie('source');
            // console.log(user_data);

            // Check for password requirements
            var pass_check = true;
            var pass_check_errors = [];
            if(user_data.password !== user_data.confirm_password){
                pass_check_errors.push("Passwords must match.");
                pass_check = false;
            }
            
            if(user_data.password.length < 5) {
                pass_check_errors.push("Password is too short (minimum is 5 characters).");
                pass_check = false;
            }

            if(user_data.no_npi_number == false){
                if(user_data.npi_number.length != 10){
                  pass_check_errors.push("NPI number should be 10 digits");
                  pass_check = false;
                }
            }

            if (typeof grecaptcha === 'undefined' || typeof grecaptcha.enterprise === 'undefined') {
                //reCaptcha not loaded
                pass_check_errors.push("Security verification failed. Please refresh the page and try again.");
                pass_check = false;
            } else {
                const token = await grecaptcha.enterprise.execute('6LdlmfQrAAAAAGXLOsceIvgtXuFUqle3N8N9YKXJ', {action: 'REGISTER'});

                // reCAPTCHA failed to execute
                if (!token) {
                    pass_check_errors.push("Security verification failed. Please refresh the page and try again.");
                    pass_check = false;
                }

                // Add the token to user_data
                user_data['recaptcha_token'] = token;
                user_data['recaptcha_action'] = 'REGISTER';
            }

            var message_div = document.createElement('div');
            message_div.setAttribute('role', 'alert');
            message_div.setAttribute('id', 'error-msg-alert');
            if(pass_check){
                var submit_btn = form.querySelector("button");
                loading(submit_btn);
                submit_btn.disabled = true;
                
                user_data = JSON.stringify(user_data);

                var request = new Request('https://app.nbpas.org/api_endpoints/post_contact.php', {
                    method: 'POST',
                    body: user_data,
                    headers: {
                        'Content-type': 'application/json'
                    }
                });

                fetch(request)
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    console.log(data);
                    
                    if(data.success){
                        if(data.state != 'enabled'){
                            // Redirect to activate account page
                            window.location.replace(data.account_activation_url);
                        } else {
                            // redirect user to login page
                            if (get_cookie('donation')) {
                            window.location.replace("/pages/donation?account_create=true");
                            } else {
                            window.location.replace("/account/login?account_create=true");
                            }
                        }
                    } else {
                        var message_div_p = document.createElement('p');
                        message_div_p.setAttribute('class', 'm-0');
                        message_div.setAttribute('class', 'alert alert-danger mt-4');
                        if(data.errors) {
                            for(error of data.errors) {
                                message_div_p.innerHTML += error + '<br>';
                            }
                        } else {
                            message_div_p.innerHTML = 'An error has ocurred. Please try again later.';
                        }

                        message_div.appendChild(message_div_p);

                        submit_btn.disabled = false;
                        finished_loading(submit_btn, "Submit");
                    }
                }).catch(function(error) { console.log("Error Posting Contact: " + error) });
            } else {
                message_div.setAttribute('class', 'alert alert-danger mt-4');
                message_div.setAttribute('role', 'alert');

                for (key in pass_check_errors){
                    var message = pass_check_errors[key];
                    // console.log(message);
                    message_div.innerHTML += message + "<br>";
                }
            }

            form.appendChild(message_div);
            window.setTimeout(function(){
                fade_in(message_div);
            }, 500);
        }

        // Forgot Email
        if(event.target.id == "forgot_email"){
            event.preventDefault();
            // console.log("submitted!");

            var forgot_email_alert = document.querySelector('#forgot-email-alert');
            if(forgot_email_alert) { fade_out(forgot_email_alert, true); }

            var form = event.target;
            // console.log(form.elements);

            // Disable button and set it to loading
            var submit_btn = form.querySelector("button");
            loading(submit_btn);
            submit_btn.disabled = true;

            // Get all input values from from
            var user_data = serialize(form);
            console.log(user_data);

            user_data = JSON.stringify(user_data);
            var request = new Request('https://app.nbpas.org/api_endpoints/get_contact_with_npi.php', {
                method: 'POST',
                body: user_data,
                headers: {
                    'Content-type': 'application/json'
                }
            });

            fetch(request)
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                // console.log(data);

                var message_div = document.createElement('div');
                message_div.setAttribute('role', 'alert');
                message_div.setAttribute('id', 'forgot-email-alert');

                if(data.success){
                    message_div.setAttribute('class', 'alert alert-success mt-4');
                } else {
                    message_div.setAttribute('class', 'alert alert-danger mt-4');
                }

                var message_div_p = document.createElement('p');
                message_div_p.setAttribute('class', 'm-0');
                message_div_p.innerHTML = data.message;
                message_div.appendChild(message_div_p);

                submit_btn.disabled = false;
                finished_loading(submit_btn, "Search");

                form.appendChild(message_div);
                window.setTimeout(function(){
                    fade_in(message_div);
                }, 500);
            }).catch(function(error) { console.log("Error Getting Contact: " + error) });
        }

        // Get Specialties or Subspecialties by type
        if(event.target.id == "get_specialties"){
            // console.log(event);
            event.preventDefault();
            var form = event.target;

            // Set active button to loading
            var active_btn = form.querySelector('button[clicked=true]');
            var active_btn_text = active_btn.innerHTML;
            loading(active_btn);

            // Disable all button on form
            var submit_btns = form.querySelectorAll("button");
            for (key in submit_btns){
                var btn = submit_btns[key];
                btn.disabled = true;
            }

            // Get all input values from from
            var user_data = serialize(form);
            user_data['opportunity_id'] = document.getElementById('opportunity_id').value;
            user_data['specialty_option'] = active_btn.value;
            // console.log(user_data);

            user_data = JSON.stringify(user_data);
            var request = new Request('https://app.nbpas.org/api_endpoints/get_specialties_by_type.php', {
                method: 'POST',
                body: user_data,
                headers: {
                    'Content-type': 'application/json'
                }
            });

            fetch(request)
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                // console.log(data);

                var specialty_modal_check = document.getElementById('pick_specialty_modal');
                if(specialty_modal_check){ specialty_modal_check.remove(); }

                var specialty_modal = document.createElement('div');
                specialty_modal.setAttribute('class', 'modal');
                specialty_modal.setAttribute('id', 'pick_specialty_modal');

                var specialty_modal_dialog = document.createElement('div');
                specialty_modal_dialog.setAttribute('class', 'modal-dialog modal-lg modal-dialog-scrollable');
                specialty_modal.appendChild(specialty_modal_dialog);

                var specialty_modal_content = document.createElement('div');
                specialty_modal_content.setAttribute('class', 'modal-content');
                specialty_modal_dialog.appendChild(specialty_modal_content);

                var specialty_modal_header = document.createElement('div');
                specialty_modal_header.setAttribute('class', 'modal-header');
                specialty_modal_content.appendChild(specialty_modal_header);

                var specialty_modal_title = document.createElement('h5');
                specialty_modal_title.setAttribute('class', 'modal-title');
                specialty_modal_title.innerHTML = (data.specialty_option == 'add_specialty') ? 'Add Specialties & Subspecialties' : 'Add Only Subspecialties';
                specialty_modal_header.appendChild(specialty_modal_title);

                var specialty_modal_close = document.createElement('button');
                specialty_modal_close.setAttribute('type', 'button');
                specialty_modal_close.setAttribute('class', 'btn-close');
                specialty_modal_close.setAttribute('data-bs-dismiss', 'modal');
                specialty_modal_close.setAttribute('aria-label', 'Close');
                specialty_modal_close.innerHTML = 'Save & Close';
                specialty_modal_header.appendChild(specialty_modal_close);

                var specialty_modal_body = document.createElement('div');
                specialty_modal_body.setAttribute('class', 'modal-body');
                specialty_modal_content.appendChild(specialty_modal_body);

                var specialty_modal_text = document.createElement('p');
                var specialties_text = 'After selecting a primary specialty, click the red plus sign to expand and see the related subspecialties. Add your selections by clicking on “Add”, then click save and close when finished.';
                var subspecialties_text = 'Please select which subspecialties you would like to add.';
                specialty_modal_text.innerHTML = (data.specialty_option == 'add_specialty') ? specialties_text : subspecialties_text;
                specialty_modal_body.appendChild(specialty_modal_text);

                var search_specialty_form = document.createElement('form');
                search_specialty_form.setAttribute('id', 'query_specialties');
                search_specialty_form.setAttribute('class', 'row row-cols-lg-auto mb-3 align-items-center');
                specialty_modal_body.appendChild(search_specialty_form);

                var search_specialty_option = document.createElement('input');
                search_specialty_option.setAttribute('type', 'hidden');
                search_specialty_option.setAttribute('name', 'specialty_option');
                search_specialty_option.setAttribute('id', 'specialty_option');
                search_specialty_option.setAttribute('value', data.specialty_option);
                search_specialty_form.appendChild(search_specialty_option);

                var search_specialty_type = document.createElement('input');
                search_specialty_type.setAttribute('type', 'hidden');
                search_specialty_type.setAttribute('name', 'specialty_type');
                search_specialty_type.setAttribute('id', 'specialty_type');
                search_specialty_type.setAttribute('value', data.specialty_type);
                search_specialty_form.appendChild(search_specialty_type);

                var search_specialty_group = document.createElement('div');
                search_specialty_group.setAttribute('class', 'input-group');
                search_specialty_form.appendChild(search_specialty_group);
                
                var search_specialty_text = document.createElement('input');
                search_specialty_text.setAttribute('class', 'form-control');
                search_specialty_text.setAttribute('type', 'text');
                search_specialty_text.setAttribute('placeholder', 'Search');
                search_specialty_text.setAttribute('name', 'query_string');
                search_specialty_text.setAttribute('id', 'query_string');
                // search_specialty_text.setAttribute('required', true);
                search_specialty_group.appendChild(search_specialty_text);

                var search_specialty_submit = document.createElement('button');
                search_specialty_submit.setAttribute('type', 'submit');
                search_specialty_submit.setAttribute('class', 'btn btn-primary');
                search_specialty_submit.innerHTML = (data.specialty_option == 'add_specialty') ? 'Search Specialty' : 'Search Subspecialty';
                search_specialty_group.appendChild(search_specialty_submit);

                var add_specialty_table = document.createElement('table');
                add_specialty_table.setAttribute('id', 'specialties_table')
                add_specialty_table.setAttribute('class', 'table table-hover align-middle');
                specialty_modal_body.appendChild(add_specialty_table);

                var specialty_table_thead = document.createElement('thead');
                add_specialty_table.appendChild(specialty_table_thead);

                var specialty_table_head_tr = document.createElement('tr');
                specialty_table_thead.appendChild(specialty_table_head_tr);

                var specialty_table_th_1 = document.createElement('th');
                specialty_table_th_1.setAttribute('scope', 'col');
                specialty_table_head_tr.appendChild(specialty_table_th_1);

                var specialty_table_th_2 = document.createElement('th');
                specialty_table_th_2.setAttribute('scope', 'col');
                var specialty_table_th_2_html = (data.specialty_option == 'add_specialty') ? 'Specialty Name' : 'Subspecialty Name'
                specialty_table_th_2.innerHTML = specialty_table_th_2_html;
                specialty_table_head_tr.appendChild(specialty_table_th_2);

                var specialty_table_th_3 = document.createElement('th');
                specialty_table_th_3.setAttribute('scope', 'col');
                specialty_table_head_tr.appendChild(specialty_table_th_3);

                var specialty_table_body = document.createElement('tbody');
                add_specialty_table.appendChild(specialty_table_body);

                display_specialty_table_rows(data, specialty_table_body);

                document.body.prepend(specialty_modal);

                var myModal = new bootstrap.Modal(document.getElementById('pick_specialty_modal'), {
                    keyboard: false
                });
                myModal.show();

                for (key in submit_btns){
                    var btn = submit_btns[key];
                    btn.disabled = false;
                }
                active_btn.setAttribute('clicked', false);
                finished_loading(active_btn, active_btn_text);
            }).catch(function(error) { console.log("Error Getting Specialties: " + error) });
        }

        // Query Specialties & Subspecialties
        if(event.target.id == "query_specialties"){
            event.preventDefault();
            var form = event.target;

            // Disable button and set it to loading
            var submit_btn = form.querySelector("button");
            loading(submit_btn);
            submit_btn.disabled = true;

            // Get all input values from from
            var user_data = serialize(form);
            user_data['opportunity_id'] = document.getElementById('opportunity_id').value;
            // console.log(user_data);

            user_data = JSON.stringify(user_data);
            var request = new Request('https://app.nbpas.org/api_endpoints/get_specialties_by_type.php', {
                method: 'POST',
                body: user_data,
                headers: {
                    'Content-type': 'application/json'
                }
            });

            fetch(request)
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                // console.log(data);

                var specialties_table_body = document.querySelector('#specialties_table tbody');
                display_specialty_table_rows(data, specialties_table_body);

                var search_text = (data.specialty_option == 'add_specialty') ? 'Search Specialty' : 'Search Subspecialty';
                finished_loading(submit_btn, search_text);
                submit_btn.disabled = false;
            }).catch(function(error) { console.log("Error Querying Specialties: " + error) });
        }

        // POST Specialty
        if(event.target.id == "add_specialty"){
            event.preventDefault();
            var form = event.target;

            // Disable button and set it to loading
            var submit_btn = form.querySelector("button");
            loading(submit_btn, 'loader', 'info');
            submit_btn.disabled = true;

            // Get all input values from from
            var user_data = serialize(form);
            user_data['opportunity_id'] = document.getElementById('opportunity_id').value;
            // console.log(user_data);

            user_data = JSON.stringify(user_data);
            var request = new Request('https://app.nbpas.org/api_endpoints/add_specialty.php', {
                method: 'POST',
                body: user_data,
                headers: {
                    'Content-type': 'application/json'
                }
            });

            fetch(request)
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                // console.log(data);

                // Get specialty index for referencing
                var specialty_index = submit_btn.getAttribute('data-specialty-index');

                // Add collapse button for subspecialties
                var specialty_collapse_btn = document.createElement('button');
                specialty_collapse_btn.setAttribute('class', 'btn btn-primary btn-sm specialty-collapse');
                specialty_collapse_btn.setAttribute('type', 'button');
                specialty_collapse_btn.setAttribute('data-bs-toggle', 'collapse');
                specialty_collapse_btn.setAttribute('data-bs-target', '.subspecialties_' + specialty_index);
                specialty_collapse_btn.innerHTML = '-';

                var collapse_btn_container = document.querySelector('.specialty_' + specialty_index + ' td');
                collapse_btn_container.appendChild(specialty_collapse_btn);

                // Add specialty opportunity id
                // so user can remove specialty opportunity
                var opportunity_id_input = document.createElement('input');
                opportunity_id_input.setAttribute('type', 'hidden');
                opportunity_id_input.setAttribute('name', 'specialty_opportunity_id');
                opportunity_id_input.setAttribute('id', 'specialty_opportunity_id');
                opportunity_id_input.setAttribute('value', data.id);
                form.appendChild(opportunity_id_input);

                // Add subspecialties
                var specialty_row = document.querySelector('.specialty_' + specialty_index);
                display_subspecialty_table_rows(data.subspecialties, data.id, specialty_index, specialty_row);

                // change form id so it now removes instead of add
                // change styles and text
                form.setAttribute('id', 'remove_specialty');
                submit_btn.setAttribute('class', 'btn btn-outline-danger btn-sm');
                finished_loading(submit_btn, 'Remove');
                submit_btn.disabled = false;

                var continue_application_btn = document.querySelector('#continue_application');
                if(continue_application_btn.disabled) {
                    continue_application_btn.disabled = false;
                }

                display_contact_opportunities();
            }).catch(function(error) { console.log("Error Posting Specialties: " + error) });
        }

        // Remove Specialty
        if(event.target.id == "remove_specialty"){
            event.preventDefault();
            var form = event.target;

            // Disable button and set it to loading
            var submit_btn = form.querySelector("button");
            loading(submit_btn, 'loader', 'danger');
            submit_btn.disabled = true;

            // Get all input values from from
            var user_data = serialize(form);
            user_data['opportunity_id'] = document.getElementById('opportunity_id').value;
            // console.log(user_data);

            user_data = JSON.stringify(user_data);
            var request = new Request('https://app.nbpas.org/api_endpoints/remove_specialty.php', {
                method: 'POST',
                body: user_data,
                headers: {
                    'Content-type': 'application/json'
                }
            });

            fetch(request)
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                // console.log(data);

                // Get specialty index for referencing
                var specialty_index = submit_btn.getAttribute('data-specialty-index');

                // Remove collapse button for subspecialties
                document.querySelector('.specialty_' + specialty_index + ' td').innerHTML = '';

                // Remove all subspecialty table rows
                var subspecialty_rows = document.querySelectorAll('tr.subspecialties_' + specialty_index);
                for (key in subspecialty_rows){
                    if (key === "entries") { break; }
                    var subspecialty_row = subspecialty_rows[key];
                    subspecialty_row.remove();
                }

                // Remove opportunity id since it doesn't exist anymore
                form.querySelector('#specialty_opportunity_id').remove();

                // change form id so it now adds instead of remove
                // change styles and text
                form.setAttribute('id', 'add_specialty');
                submit_btn.setAttribute('class', 'btn btn-outline-info btn-sm');
                finished_loading(submit_btn, 'Add');
                submit_btn.disabled = false;

                var continue_application_btn = document.querySelector('#continue_application');
                if(data.specialty_count == 0) {
                    continue_application_btn.disabled = true;
                } else {
                    continue_application_btn.disabled = false;
                }

                display_contact_opportunities();
            }).catch(function(error) { console.log("Error Removing Specialty: " + error) });
        }

        // POST Subspecialties
        if(event.target.id == "add_subspecialty"){
            event.preventDefault();
            var form = event.target;

            // Disable button and set it to loading
            var submit_btn = form.querySelector("button");
            loading(submit_btn, 'loader', 'info');
            submit_btn.disabled = true;

            // Get all input values from from
            var user_data = serialize(form);
            user_data['opportunity_id'] = document.getElementById('opportunity_id').value;
            // console.log(user_data);

            user_data = JSON.stringify(user_data);
            var request = new Request('https://app.nbpas.org/api_endpoints/add_subspecialty.php', {
                method: 'POST',
                body: user_data,
                headers: {
                    'Content-type': 'application/json'
                }
            });

            fetch(request)
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                // console.log(data);

                // Add specialty opportunity id
                // so user can remove specialty opportunity
                var opportunity_id_input = document.createElement('input');
                opportunity_id_input.setAttribute('type', 'hidden');
                opportunity_id_input.setAttribute('name', 'subspecialty_opportunity_id');
                opportunity_id_input.setAttribute('id', 'subspecialty_opportunity_id');
                opportunity_id_input.setAttribute('value', data.id);
                form.appendChild(opportunity_id_input);

                // change form id so it now removes instead of add
                // change styles and text
                form.setAttribute('id', 'remove_subspecialty');
                submit_btn.setAttribute('class', 'btn btn-outline-danger btn-sm');
                finished_loading(submit_btn, 'Remove');
                submit_btn.disabled = false;

                var continue_application_btn = document.querySelector('#continue_application');
                if(continue_application_btn.disabled) {
                    continue_application_btn.disabled = false;
                }

                display_contact_opportunities();
            }).catch(function(error) { console.log("Error Posting Subspecialties: " + error) });
        }

        // Remove Subspecialty
        if(event.target.id == "remove_subspecialty"){
            event.preventDefault();
            var form = event.target;

            // Disable button and set it to loading
            var submit_btn = form.querySelector("button");
            loading(submit_btn, 'loader', 'danger');
            submit_btn.disabled = true;

            // Get all input values from from
            var user_data = serialize(form);
            user_data['opportunity_id'] = document.getElementById('opportunity_id').value;
            // console.log(user_data);

            user_data = JSON.stringify(user_data);
            var request = new Request('https://app.nbpas.org/api_endpoints/remove_subspecialty.php', {
                method: 'POST',
                body: user_data,
                headers: {
                    'Content-type': 'application/json'
                }
            });

            fetch(request)
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                // console.log(data);

                // Remove opportunity id since it doesn't exist anymore
                form.querySelector('#subspecialty_opportunity_id').remove();

                // change form id so it now adds instead of remove
                // change styles and text
                form.setAttribute('id', 'add_subspecialty');
                submit_btn.setAttribute('class', 'btn btn-outline-info btn-sm');
                finished_loading(submit_btn, 'Add');
                submit_btn.disabled = false;

                // Disable button to continue with application
                var continue_application_btn = document.querySelector('#continue_application');
                if(data.specialty_count == 0) {
                    continue_application_btn.disabled = true;
                } else {
                    continue_application_btn.disabled = false;
                }

                display_contact_opportunities();
            }).catch(function(error) { console.log("Error Removing Subspecialty: " + error) });
        }

        // Add paper certificates and go to checkout
        if(event.target.id == "add_certificates_checkout") {
            event.preventDefault();
            console.log('Form submitted');
            var form = event.target;

            // Disable button and set it to loading
            var submit_btn = form.querySelector("button");
            loading(submit_btn);
            submit_btn.disabled = true;

            // Get all input values from from
            var user_data = serialize(form);
            var paper_cert_qty = user_data['paper_certificate_qty'];
            var is_military = user_data['is_military'];
            var is_fellow = user_data['is_fellow'];
            var is_board_member = user_data['is_board_member'];
            // user_data['opportunity_id'] = document.getElementById('opportunity_id').value;
            // console.log(user_data);

            if(paper_cert_qty < 0) {
                document.querySelector('#paper_certificate_qty').classList.add('is-invalid');
                finished_loading(submit_btn, 'Add Certificates & Checkout');
                submit_btn.disabled = false;
            } else {
                update_application_step('Checkout');
                document.querySelector('#paper_certificate_qty').classList.remove('is-invalid');

                // Redirect user to checkout
                // Add board certification product
                // and paper certificates
                var checkout_url = 'https://nbpas.myshopify.com/cart/';

                if(is_military == 'true'){
                    checkout_url += '41279975391437:1';
                } else if(is_fellow == 'true'){
                    checkout_url += '41176171249869:1';
                } else if(is_board_member == 'true'){
                    checkout_url += '41384504426701:1';
                } else {
                    checkout_url += '40109821296845:1';
                }

                if (paper_cert_qty > 0){
                    checkout_url += ',40413121839309:' + paper_cert_qty;
                }

                
                  var expediteShipping = get_cookie('expedite_shipping');
                  if (expediteShipping === 'true') {
                    checkout_url += ',41895370195149:1';
                  }
                

                setTimeout(function () {
                    window.location.replace(checkout_url);
                }, 2000);
            }
        }

        // Add addtional paper certificates to in progress or active opportunity
        if(event.target.id == "add_paper_certificate") {
            event.preventDefault();
            var form = event.target;

            // Disable button and set it to loading
            var submit_btn = form.querySelector("button");
            loading(submit_btn);
            submit_btn.disabled = true;

            // Get all input values from from
            var user_data = serialize(form);
            var paper_cert_qty = user_data['paper_certificate_qty'];
            var variant_id = user_data['variant_id'];
            // var is_military = user_data['is_military'];
            // var is_fellow = user_data['is_fellow'];
            // console.log(user_data);

            var checkout_url = 'https://nbpas.myshopify.com/cart/'+ variant_id +':' + paper_cert_qty;

            // Add fellow or military discount
            // if(is_military == 'true'){
            //     checkout_url += '?discount=MILITARY';
            // } else if(is_fellow == 'true'){
            //     checkout_url += '?discount=FELLOW';
            // }
            window.location.replace(checkout_url);
        }

        // Verify Certifications
        if (event.target.id == "verify-certification-home") {
            event.preventDefault();

            var form = event.target;
            var formData = new FormData(form);
            var searchType = formData.get('search-type');
            var redirectUrl;

            if (searchType === 'name') {
                var firstName = formData.get('first-name');
                var lastName = formData.get('last-name');
                redirectUrl = "/pages/verify-certification-result?firstname=" + firstName + "&lastname=" + lastName;
            } else {
                var searchId = formData.get('search-id');
                redirectUrl = "/pages/verify-certification-result?id=" + searchId;
            }

            window.location.replace(redirectUrl);
        }

        // Reset Password
        if(event.target.id == "reset_password") {
            event.preventDefault();
            var form = event.target;

            // Disable button and set it to loading
            var submit_btn = form.querySelector("button");
            loading(submit_btn);
            submit_btn.disabled = true;

            // Get all input values from from
            var user_data = serialize(form);
            // console.log(user_data);

            user_data = JSON.stringify(user_data);
            var request = new Request('https://app.nbpas.org/api_endpoints/reset_password.php', {
                method: 'POST',
                body: user_data,
                headers: {
                    'Content-type': 'application/json'
                }
            });

            fetch(request)
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                // console.log(data);

                if(data.customer){
                    // redirect user to application page
                    window.location.replace("/account/login?reset_password=true");
                }

                // finished_loading(submit_btn, 'Submit');
                // submit_btn.disabled = false;
            }).catch(function(error) { console.log("Error Resetting Password: " + error) });
        }

        // Account Login Email Check
        // Checks the state of the account
        if(event.target.id == "login_email_check") {
            event.preventDefault();
            var form = event.target;

            // remove alert if any
            var alert = form.querySelector('.alert');
            if(alert){ alert.remove() }

            // Disable button and set it to loading
            var submit_btn = form.querySelector("button");
            loading(submit_btn, 'icon', 'light');
            submit_btn.disabled = true;

            // Get all input values from from
            var user_data = serialize(form);
            // console.log(user_data);

            user_data = JSON.stringify(user_data);
            var request = new Request('https://app.nbpas.org/api_endpoints/login_email_check.php', {
                method: 'POST',
                body: user_data,
                headers: {
                    'Content-type': 'application/json'
                }
            });

            fetch(request)
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                // console.log(data);

                if(data.success){
                    // Account with email doesn't exist
                    var registerUrl = '/account/register';
                    if (window.location.pathname === '/pages/donation') {
                      registerUrl += '?donation=true';
                    }
                    var message_div = document.createElement('div');
                    message_div.setAttribute('class', 'alert alert-danger mt-4 mb-0 py-2');
                    message_div.innerHTML = 'We do not recognize your account, please <a href="' + registerUrl + '">create an account</a>';

                    form.appendChild(message_div);
                } else {
                    var customer_login_form = document.querySelector('form#customer_login');
                    if(data.state != 'enabled'){
                        // Redirect to activate account page
                        window.location.replace(data.account_activation_url);

                        // Show active account
                        // var active_account = document.querySelector('#active_account');
                        // active_account.classList.remove('d-none');

                        // Hide account login
                        // customer_login_form.classList.add('d-none');
                    } else {
                        // Show Login form
                        customer_login_form.classList.remove('d-none');

                        // Add email to email input
                        customer_login_form.querySelector('#CustomerEmail').value = data.email;
                    }

                    // Hide email check form
                    form.classList.add('d-none');
                }

                finished_loading(submit_btn, '<i class="bi bi-chevron-right"></i>');
                submit_btn.disabled = false;
            });
        }

        // Lead From
        if (event.target.id == "lead_form") {
            event.preventDefault();
            // console.log("submitted!");

            var form = event.target;
            // console.log(form.elements);

            // Disable button and set it to loading
            var submit_btn = form.querySelector("button");
            loading(submit_btn);
            submit_btn.disabled = true;

            // Get all input values from from
            var user_data = serialize(form);
            // console.log(user_data);

            user_data = JSON.stringify(user_data);
            var request = new Request('https://app.nbpas.org/api_endpoints/create_new_lead.php', {
                method: 'POST',
                body: user_data,
                headers: {
                    'Content-type': 'application/json'
                }
            });

            fetch(request)
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                // console.log(data);

                var container = document.querySelector('#lead_form_container');
                container.innerHTML = data;
            }).catch(function (error) { console.log("Error Inserting Lead: " + error) });
        }

        // Webinar tracking
        if (event.target.id == "webinar_apply") {
            event.preventDefault();

            set_cookie("webinar_apply", "true", 14);
            window.location.replace('/account/login');
        }

        // Newsletter Subscription
        if (event.target.id == "newsletter_signup") {
            event.preventDefault();
            // console.log("submitted!");

            var form = event.target;
            // console.log(form.elements);

            // Hide success and error messages
            var success_msg = form.querySelector(".success-msg");
            success_msg.classList.add("d-none");
            var error_msg = form.querySelector(".error-msg");
            error_msg.classList.add("d-none");

            // Disable button and set it to loading
            var submit_btn = form.querySelector("button");
            var submitBtnLabel = submit_btn.innerHTML;
            loading(submit_btn);
            submit_btn.disabled = true;

            // Get all input values from from
            var user_data = serialize(form);
            // console.log(user_data);

            if (typeof grecaptcha === 'undefined' || typeof grecaptcha.enterprise === 'undefined') {
                //reCaptcha not loaded
                pass_check_errors.push("Security verification failed. Please refresh the page and try again.");
                pass_check = false;
            } else {
                const token = await grecaptcha.enterprise.execute('6LdlmfQrAAAAAGXLOsceIvgtXuFUqle3N8N9YKXJ', {action: 'SIGNUP'});

                // reCAPTCHA failed to execute
                if (!token) {
                    pass_check_errors.push("Security verification failed. Please refresh the page and try again.");
                    pass_check = false;
                }

                // Add the token to user_data
                user_data['recaptcha_token'] = token;
                user_data['recaptcha_action'] = 'SIGNUP';
            }

            user_data = JSON.stringify(user_data);
            var request = new Request('https://app.nbpas.org/api_endpoints/newsletter_signup.php', {
                method: 'POST',
                body: user_data,
                headers: {
                    'Content-type': 'application/json'
                }
            });

            fetch(request)
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    console.log(data);

                    if(data.success){
                        form.reset();
                        success_msg.classList.remove("d-none");
                    } else {
                        error_msg.classList.remove("d-none");
                    }

                    finished_loading(submit_btn, submitBtnLabel);
                    submit_btn.disabled = false;
                }).catch(function (error) { console.log("Error Inserting Lead: " + error) });
        }

        // Update Email Request
        if (event.target.id == "update_contact_email") {
            event.preventDefault();
            // console.log("submitted!");

            var form = event.target;
            // console.log(form.elements);

            // Hide success and error messages
            var error_msg = form.querySelector(".error-msg");
            error_msg.classList.add("d-none");

            // Disable button and set it to loading
            var submit_btn = form.querySelector("button");
            loading(submit_btn);
            submit_btn.disabled = true;

            // Get all input values from from
            var user_data = serialize(form);
            // console.log(user_data);

            user_data = JSON.stringify(user_data);
            var request = new Request('https://app.nbpas.org/api_endpoints/update_email.php', {
                method: 'POST',
                body: user_data,
                headers: {
                    'Content-type': 'application/json'
                }
            });

            fetch(request)
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    // console.log(data);

                    if (data.success) {
                        var modal_body = document.querySelector("#update_email_modal .modal-body");
                        modal_body.classList.add("text-center");

                        var success_msg = '<p class="text-success">Email updated successfully!</p>';
                        success_msg += '<button type="button" class="btn btn-primary" data-bs-dismiss="modal">Close</button>';
                        modal_body.innerHTML = success_msg;

                        document.querySelector("#email").value = data.new_email;
                    } else {
                        error_msg.innerHTML = data.message;
                        error_msg.classList.remove("d-none");

                        finished_loading(submit_btn, 'Submit');
                        submit_btn.disabled = false;
                    }
                }).catch(function (error) { console.log("Error Creating Case: " + error) });
        }

        if(event.target.id == 'ama-petition') {
            event.preventDefault();
            var form = event.target;

            // Hide alerts
            let alertSuccess = document.querySelector('.alert-success');
            let alertDanger = document.querySelector('.alert-danger');
            alertDanger.classList.add('d-none');
            alertSuccess.classList.add('d-none');

            // Validate form
            let validate_form = validateForm(form);
            // console.log(validate_form);

            if (validate_form.length == 0) {
              // Disable button and set it to loading
              var submit_btn = form.querySelector("button");
              loading(submit_btn);
              submit_btn.disabled = true;
  
              // Get all input values from from
              var user_data = serialize(form);
              console.log(user_data);
  
              user_data = JSON.stringify(user_data);
              var request = new Request('https://app.nbpas.org/api_endpoints/forms/submit_lead.php', {
                  method: 'POST',
                  body: user_data,
                  headers: {
                      'Content-type': 'application/json'
                  }
              });
  
              fetch(request)
              .then(function (response) {
                  return response.json();
              })
              .then(function (data) {
                  console.log(data);
  
                  if(data.success == true) {
                    clearForm(form);
                    alertSuccess.innerHTML = 'Petition successfully signed.';
                    alertSuccess.classList.remove('d-none');
                  } else {
                    alertDanger.innerHTML = 'Error submitting information.';
                    alertDanger.classList.remove('d-none');
                  }
                
                  finished_loading(submit_btn, 'Next');
                  submit_btn.disabled = false;
              }).catch(function (error) { console.log("Error Submitting Lead: " + error) });
            } else {
              alertDanger.innerHTML = 'Please fill out all required fields.';
              // alertDanger.innerHTML = validate_form.join('<br>');
              alertDanger.classList.remove('d-none');
            }
        }
    });

    // Make NPI required only if 'no npi' checkbox is checked
    document.body.addEventListener("change", function (event) {
        if(event.target.id == 'no_npi_number'){
            var npi_input = document.querySelector('#npi_number');
            if (event.target.checked) {
                // Make NPI optional
                npi_input.required = false;
            } else {
                // Make NPI required
                npi_input.required = true;
            }
        }

        // Autopopulate practice address when user
        // checks the mailing equal practice checkbox
        if(event.target.id == 'practice_equal_mailing') {
            var practice_address = document.querySelector('#practice_address');
            if (event.target.checked) {
                practice_address.classList.add("d-none");
              
                var mailing_street = document.querySelector('#mailing_street');
                var mailing_city = document.querySelector('#mailing_city');
                var mailing_state = document.querySelector('#mailing_state');
                var mailing_state_int = document.querySelector('#mailing_state_int');
                var mailing_zip = document.querySelector('#mailing_zip');
                var mailing_country = document.querySelector('#mailing_country');

                var practice_street = document.querySelector('#practice_street');
                var practice_city = document.querySelector('#practice_city');
                var practice_state = document.querySelector('#practice_state');
                var practice_state_int = document.querySelector('#practice_state_int');
                var practice_zip = document.querySelector('#practice_zip');
                var practice_country = document.querySelector('#practice_country');

                practice_street.value = mailing_street.value;
                practice_city.value = mailing_city.value;
                practice_state.value = mailing_state.value;
                practice_state_int.value = mailing_state_int.value;
                practice_zip.value = mailing_zip.value;
                practice_zip_int.value = mailing_zip_int.value;
                practice_country.value = mailing_country.value;

                if (mailing_country.value != "United States") {
                    practice_state_int.classList.remove("d-none");
                    practice_zip_int.classList.remove("d-none");

                    practice_state.classList.add("d-none");
                    practice_zip.classList.add("d-none");
                } else {
                    practice_state_int.classList.add("d-none");
                    practice_zip_int.classList.add("d-none");

                    practice_state.classList.remove("d-none");
                    practice_zip.classList.remove("d-none");
                }
            } else {
                practice_address.classList.remove("d-none");
            }
        }

        if(event.target.id == 'license-exp-year' || event.target.id == 'license-exp-month'){
            var licenseExpMonth = document.querySelector('#license-exp-month').value;
            var licenseExpYear = document.querySelector('#license-exp-year').value;
            licenseExpirationCheck(licenseExpMonth, licenseExpYear);
        }

        var militaryEvidence = document.querySelector('#military-evidence');
        if(event.target.id == 'is-military'){
            if(event.target.checked){
                var isFellow = document.querySelector('#is-fellow');
                isFellow.checked = false;
                militaryEvidence.classList.remove('d-none');
            } else {
                militaryEvidence.classList.add('d-none');
            }
        }

        if(event.target.id == 'is-fellow'){
            if(event.target.checked){
                var isMilitary = document.querySelector('#is-military');
                isMilitary.checked = false;
                militaryEvidence.classList.add('d-none');
            }
        }

        if (event.target.id == 'mailing-country') {
            const mailingStateInt = document.querySelector("#mailing-state-int");
            const mailingStateZip = document.querySelector("#mailing-zip-int");
            const mobilePhoneInt = document.querySelector("#mobile-phone-int");
            const businessPhoneInt = document.querySelector("#business-phone-int");

            const mailingState = document.querySelector("#mailing-state");
            const mailingZip = document.querySelector("#mailing-zip");
            const mobilePhone = document.querySelector("#mobile-phone");
            const businessPhone = document.querySelector("#business-phone");
            if (event.target.value != "United States"){
                mailingStateInt && mailingStateInt.classList.remove("d-none");
                mailingStateZip && mailingStateZip.classList.remove("d-none");
                mobilePhoneInt && mobilePhoneInt.classList.remove("d-none");
                businessPhoneInt && businessPhoneInt.classList.remove("d-none");

                mailingState && mailingState.classList.add("d-none");
                mailingZip && mailingZip.classList.add("d-none");
                mobilePhone && mobilePhone.classList.add("d-none");
                businessPhone && businessPhone.classList.add("d-none");
            } else {
                mailingStateInt && mailingStateInt.classList.add("d-none");
                mailingStateZip && mailingStateZip.classList.add("d-none");
                mobilePhoneInt && mobilePhoneInt.classList.add("d-none");
                businessPhoneInt && businessPhoneInt.classList.add("d-none");

                mailingState && mailingState.classList.remove("d-none");
                mailingZip && mailingZip.classList.remove("d-none");
                mobilePhone && mobilePhone.classList.remove("d-none");
                businessPhone && businessPhone.classList.remove("d-none");

            }
        }

        if (event.target.id == 'practice-country') {
            if (event.target.value != "United States") {
                document.querySelector("#practice-state-int").classList.remove("d-none");
                document.querySelector("#practice-zip-int").classList.remove("d-none");

                document.querySelector("#practice-state").classList.add("d-none");
                document.querySelector("#practice-zip").classList.add("d-none");
            } else {
                document.querySelector("#practice-state-int").classList.add("d-none");
                document.querySelector("#practice-zip-int").classList.add("d-none");

                document.querySelector("#practice-state").classList.remove("d-none");
                document.querySelector("#practice-zip").classList.remove("d-none");
            }
        }

        if(event.target.id == 'search-hospital-state') {
            if (typeof HospitalManager !== 'undefined' && HospitalManager.searchHospitals) {
                HospitalManager.searchHospitals();
            }
        }

        if(event.target.id == "how_did_you_hear_about_us"){
          var value = document.querySelector("#how_did_you_hear_about_us").value;
          switch (value) {
            case "Social Media":
              document.querySelector("#social_media_wrapper").classList.remove("d-none");
              document.querySelector("#online_web_wrapper").classList.add("d-none");
              document.querySelector("#nbpas_diplomate_wrapper").classList.add("d-none");
              break;
            case "Online/Web":
              document.querySelector("#online_web_wrapper").classList.remove("d-none");
              document.querySelector("#social_media_wrapper").classList.add("d-none");
              document.querySelector("#nbpas_diplomate_wrapper").classList.add("d-none");
              break;
            case "NBPAS Diplomate":
              document.querySelector("#nbpas_diplomate_wrapper").classList.remove("d-none");
              document.querySelector("#online_web_wrapper").classList.add("d-none");
              document.querySelector("#social_media_wrapper").classList.add("d-none");
              break;
            default:
              document.querySelector("#social_media_wrapper").classList.add("d-none");
              document.querySelector("#online_web_wrapper").classList.add("d-none");
              document.querySelector("#nbpas_diplomate_wrapper").classList.add("d-none");
          }
        }

        if(event.target.id == 'license-state'){
            const licenseState = event.target.value;
            if (['MS', 'PR', 'VI'].includes(licenseState)) {
                const modal = new bootstrap.Modal(document.getElementById('license-modal'));
                modal.show();
            }
        }

        if (event.target.id == 'search-type') {
            var isName = event.target.value === 'name';
            document.getElementById('name-fields').classList.toggle('d-none', !isName);
            document.getElementById('id-fields').classList.toggle('d-none', isName);
        }
    });

    document.body.addEventListener("click", function (event) {
        // console.log(event.target);
        // Update icon on specialties table on the Application page.
        if (event.target.classList.contains('specialty-collapse')) {
            event.target.innerHTML = (event.target.classList.contains('collapsed')) ? '+' : '-';
        }

        if (event.target.getAttribute('data-action') == 'get_specialties_submit') {
            event.target.setAttribute('clicked', true);
        }

        if (event.target.id == 'save_application') {
            loading(event.target);
            event.target.disabled = true;

            var saved_application_success = document.querySelector('#saved_application_success');
            if(saved_application_success) {
                saved_application_success.remove();
            }

            setTimeout(function(){
                finished_loading(event.target, 'Save Application');
                event.target.disabled = false;

                var success_msg = document.createElement('p');
                success_msg.setAttribute('id', 'saved_application_success')
                success_msg.setAttribute('class', 'text-success mb-0 mt-2');
                success_msg.innerHTML = 'Application successfully saved!';
                insert_after(success_msg, event.target.parentNode);

                setTimeout(function(){
                    fade_out(success_msg, true);
                }, 3000);
            }, 2000);
        }

        if (event.target.id == 'save_uploads') {
            loading(event.target);
            event.target.disabled = true;

            setTimeout(function(){
                window.location.replace('/pages/account-actions');
            }, 2000);
        }

        if (event.target.id == 'additional_paper_cert') {
            console.log("additional_paper_cert");
            var status = event.target.getAttribute('status');
            console.log(status)
            var variant_id = document.querySelector('form#add_paper_certificate #variant_id');
            if(status == 'In Progress'){
                variant_id.value = '40413121839309';
            } else if(status == 'Certified'){
                variant_id.value = '40756035715277';
            }
        }
    });

    var registerForm = document.querySelector('form[action="/account"]');
    if (registerForm) {
      registerForm.addEventListener('submit', function(event) {
        event.preventDefault();
        window.location.replace('/account/register');
      });
    }

    // Hospital Privileges Form
    // Get hospital info from salesforce and display it
    var hospital_privileges = document.querySelector('#hospital_privileges');
    if(hospital_privileges){
        var salesforce_id = hospital_privileges.getAttribute('data-sf-id');

        var user_data = {};
        user_data['salesforce_id'] = salesforce_id;
        // console.log(user_data);

        user_data = JSON.stringify(user_data);
        var request = new Request('https://app.nbpas.org/api_endpoints/get_in_progress_opportunity.php', {
            method: 'POST',
            body: user_data,
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            // console.log(data);

            if(data.success) {
                data = JSON.parse(data.data);
                // console.log(data);

                if(data.Hospital_Name__c || data.Hospital_Street__c) {
                    // Get form elements first
                    var form = document.querySelector('#operative_pathway_form');
                    var form_inputs = form.elements;
                    // console.log(form_inputs);

                    // Loop through update contact form fields and enter existing information
                    var empty_fields_array = [];
                    for (i = form_inputs.length - 1; i >= 0; i = i - 1) {
                        if (form_inputs[i].name === "") {
                            continue;
                        }

                        // Get salesforce API name from field mapping object declared above
                        var sf_api_name = form_inputs[i].getAttribute('sf-api-name');

                        // Check if field mapping exists and check if the data received from salesforce is not empty.
                        if(sf_api_name && data[sf_api_name]){
                            var field_input = form.querySelector('#' + form_inputs[i].name);
                            switch (form_inputs[i].nodeName) {
                                case 'INPUT':
                                    switch (form_inputs[i].type) {
                                        case 'checkbox':
                                            field_input.checked = data[sf_api_name];
                                            break;
                                        default:
                                            field_input.value = data[sf_api_name];
                                            break;
                                    }
                                    break;
                                default:
                                    field_input.value = data[sf_api_name];
                                    break;
                            }
                        } else {
                            // Push items into array if input label has the required attribute.
                            if(form_inputs[i].labels[0].hasAttribute('required')){
                                empty_fields_array.push(form_inputs[i].labels[0].innerHTML);
                            }
                        }
                    }

                    // Account Page
                    // Display warning message if required fields are empty.
                    if (empty_fields_array !== undefined && empty_fields_array.length > 0) {
                        var message_div = document.createElement('div');
                        message_div.setAttribute('class', 'alert alert-warning mt-4');

                        var message_div_h5 = document.createElement('h5');
                        message_div_h5.setAttribute('class', 'fw-bold');
                        message_div_h5.innerHTML = 'MISSING INFORMATION';
                        message_div.append(message_div_h5);

                        var message_div_p = document.createElement('p');
                        message_div_p.setAttribute('class', 'm-0');
                        message_div_p.innerHTML = 'In order to continue with your Board Certification, please make sure you fill out the following fields: ';
                        message_div_p.innerHTML += '<b>' + empty_fields_array.join(", ") + '</b>';
                        message_div.append(message_div_p);

                        form.prepend(message_div);
                    }
                }

                // Enable form buttons after data has loaded.
                var op_form_submit = document.querySelector('#operative_pathway_form button[type="submit"]');
                var nop_form_submit = document.querySelector('#non_operative_pathway_form button[type="submit"]');

                op_form_submit.disabled = false;
                nop_form_submit.disabled = false;
            } else {
                // redirect user to application page
                // window.location.replace("/account");
            }
        }).catch(function(error) { console.log("Error Getting Contact: " + error) });
    }

    // Show Current Application
    var nbpas_application = document.querySelector('#nbpas_application_review');
    if(nbpas_application){
        display_contact_opportunities();
    }

    var individual_verification = document.querySelector('#verify_individual');
    if(individual_verification){
        display_individual_verification(individual_verification);
    }

    var print_individial_verification = document.querySelector('#print_individial_verification');
    if(print_individial_verification){
        display_print_verification(print_individial_verification);
    }

    var print_pdf_certificate = document.querySelector('#print_pdf_certificate');
    if(print_pdf_certificate){
        display_print_pdf_certificate(print_pdf_certificate);
    }

    var my_applications_btn = document.querySelector('#my_applications_link');
    if(my_applications_btn){
        var salesforce_id = document.querySelector('[data-sf-id]').getAttribute('data-sf-id');
        var user_data = {};
        user_data['salesforce_id'] = salesforce_id;
        // console.log(user_data);

        user_data = JSON.stringify(user_data);
        var request = new Request('https://app.nbpas.org/api_endpoints/get_applications_count.php', {
            method: 'POST',
            body: user_data,
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            // console.log(data);
            var applications_count_input = document.createElement('input');
            applications_count_input.setAttribute('type', 'hidden');
            applications_count_input.setAttribute('id', 'applications_count');
            applications_count_input.setAttribute('name', 'applications_count');
            applications_count_input.setAttribute('value', data.applications_count);
            document.body.appendChild(applications_count_input);

            my_applications_btn.disabled = (data.applications_count > 0) ? false : true;
        });
    }

    var specialty_count = document.querySelector('#specialty_count');
    if(specialty_count){
        var salesforce_id = specialty_count.getAttribute('data-sf-id');

        var user_data = {};
        user_data['salesforce_id'] = salesforce_id;
        // console.log(user_data);

        user_data = JSON.stringify(user_data);
        var request = new Request('https://app.nbpas.org/api_endpoints/get_specialty_count.php', {
            method: 'POST',
            body: user_data,
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            // console.log(data);

            // Assign new value to specialty count
            specialty_count.value = data.specialty_count;

            if(data.specialty_count > 0) {
                var continue_application_btn = document.querySelector('#continue_application');
                continue_application_btn.disabled = false;
            }
        }).catch(function(error) { console.log("Error Getting Specialty Count: " + error) });
    }

    var opportunity_id = document.querySelector("#opportunity_id");
    if(opportunity_id){
        var salesforce_id = opportunity_id.getAttribute('data-sf-id');

        var user_data = {};
        user_data['salesforce_id'] = salesforce_id;
        // console.log(user_data);

        user_data = JSON.stringify(user_data);
        var request = new Request('https://app.nbpas.org/api_endpoints/get_opportunity_id.php', {
            method: 'POST',
            body: user_data,
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            // console.log(data);

            var add_specialties_btn = document.querySelectorAll('#get_specialties button[type="submit"]');
            if(data.success == false) {
                user_data = {};
                user_data['contact_id'] = data.contact_id;
                user_data = JSON.stringify(user_data);

                var request = new Request('https://app.nbpas.org/api_endpoints/create_opportunity.php', {
                    method: 'POST',
                    body: user_data,
                    headers: {
                        'Content-type': 'application/json'
                    }
                });

                fetch(request)
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    // console.log(data);
                    data = JSON.parse(data);
                    opportunity_id.value = data.id;

                    if(add_specialties_btn){
                        for (key in add_specialties_btn){
                            var btn = add_specialties_btn[key];
                            btn.disabled = false;
                        }
                    }
                }).catch(function(error) { console.log("Error Creating Opportunity: " + error) });
            } else {
                if(data.in_progress){
                    // User has an in progress opportunity
                    // redirect to my applications page
                    window.location.replace("/pages/my-applications");
                } else if(!data.license_number) {
                    // User has missing information
                    // redirect to account page
                    window.location.replace("/account");
                } else {
                    opportunity_id.value = data.opportunity_id;

                    // check for checkout button
                    // var checkout_btn = document.querySelector('#checkout');
                    // if(checkout_btn){
                    //     if(data.is_military){
                    //         checkout_btn.setAttribute('onclick', "location.href='https://nbpas.myshopify.com/cart/40109821296845:1?discount=MILITARY'");
                    //     } else if(data.is_fellow){
                    //         checkout_btn.setAttribute('onclick', "location.href='https://nbpas.myshopify.com/cart/40109821296845:1?discount=FELLOW'");
                    //     }
                    // }

                    // check for Add certificates and checkout form
                    var add_cert_checkout = document.querySelector('form#add_certificates_checkout');
                    if(add_cert_checkout){
                        if(data.is_military){
                            add_cert_checkout.querySelector('#is_military').value = true;
                        } else if(data.is_fellow){
                            add_cert_checkout.querySelector('#is_fellow').value = true;
                        } else if(data.is_board_member){
                            add_cert_checkout.querySelector('#is_board_member').value = true;
                        }
                    }

                    if(add_specialties_btn){
                        for (key in add_specialties_btn){
                            var btn = add_specialties_btn[key];
                            btn.disabled = false;
                        }
                    }
                }
            }
        }).catch(function(error) { console.log("Error Getting Opportunity Id: " + error) });
    }

    var new_user_id = document.querySelector('#new_user_id');
    if(new_user_id){
        var contact_id = document.querySelector('#sf_contact_id').value;

        var user_data = {};
        user_data['contact_id'] = contact_id;
        // console.log(user_data);

        user_data = JSON.stringify(user_data);
        var request = new Request('https://app.nbpas.org/api_endpoints/get_new_user_id.php', {
            method: 'POST',
            body: user_data,
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            // console.log(data);
            new_user_id.value = data.new_user_id;
        });
    }

    // Login page success messages
    var customer_login = document.querySelector('#customer_login');
    if(customer_login){
        var url_string = window.location.href;
        var url = new URL(url_string);
        var account_create = url.searchParams.get("account_create");
        var reset_pass = url.searchParams.get("reset_password");
        var checkout_url = url.searchParams.get("checkout_url");
        // console.log(account_create);

        if(account_create){
            var create_account_success = document.querySelector('#create_account_success');
            create_account_success.classList.remove('d-none');
        }

        if(reset_pass){
            var reset_pass_success = document.querySelector('#reset_pass_success');
            reset_pass_success.classList.remove('d-none');
        }

        if(checkout_url || account_create){
            var login_email_check = document.querySelector('#login_email_check');
            login_email_check.classList.add('d-none');

            var customer_login = document.querySelector('#customer_login');
            customer_login.classList.remove('d-none');
        }
    }

    // Renew check on page actions page
    var page_actions = document.querySelector('#page_actions');
    if(page_actions){
        var contact_sf_id = page_actions.getAttribute('contact-sf-id');

        var user_data = {};
        user_data['salesforce_id'] = contact_sf_id;
        // console.log(user_data);

        user_data = JSON.stringify(user_data);
        var request = new Request('https://app.nbpas.org/api_endpoints/get_dashboard.php', {
            method: 'POST',
            body: user_data,
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
        .then(function(response) {
            return response.json();
        })
        .then(function(data) {
            // console.log(data);
            page_actions.innerHTML = data;
        });
    }

    // Accepting Hospitals
    var hospital_list = document.querySelector("#hospital_list");
    if (hospital_list) {
        var request = new Request('https://app.nbpas.org/api_endpoints/get_accepting_hospitals.php', {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            // console.log(data);
            var last_modified_date = document.querySelector("#last_modified_date");
            last_modified_date.innerHTML = data.last_modified_date;
          
            hospital_list.innerHTML = data.html;
        });
    }

    // FAQs
    var nbpas_faqs = document.querySelector("#nbpas_faqs");
    if (nbpas_faqs) {
        var request = new Request('https://app.nbpas.org/api_endpoints/get_faqs.php', {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                // console.log(data);
                nbpas_faqs.innerHTML = data;
            });
    }

    // Specialties Offered
    var specialties_offered = document.querySelector("#specialties_offered");
    if (specialties_offered) {
        var request = new Request('https://app.nbpas.org/api_endpoints/get_specialties_offered_v3.php', {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                // console.log(data);
                specialties_offered.innerHTML = data;
            });
    }

    // Specialties Offered
    var account_menu = document.querySelector("#account_menu");
    if (account_menu) {
        var user_data = {};
        var salesforce_id = account_menu.getAttribute("data-sf-id");
        user_data['salesforce_id'] = salesforce_id;
        user_data = JSON.stringify(user_data);
        var request = new Request('https://app.nbpas.org/api_endpoints/get_account_menu.php', {
            method: 'POST',
            body: user_data,
            headers: {
                'Content-type': 'application/json'
            }
        });

        fetch(request)
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                // console.log(data);
                var account_dropdown_menu = account_menu.querySelector(".dropdown-menu");
                account_dropdown_menu.innerHTML = data;
            });
    }

    var application_sidebar = document.querySelector("#application_sidebar");
    if(application_sidebar){
      var step = application_sidebar.getAttribute("data-step");
      var contact_id = application_sidebar.getAttribute("contact-sf-id");
      var heading = application_sidebar.getAttribute("data-heading");
      
      var user_data = {};
      user_data["step"] = step;
      user_data["contact_id"] = contact_id;
      user_data["heading"] = heading;

      user_data = JSON.stringify(user_data);

      // 1. Create a new XMLHttpRequest object
      let xhr = new XMLHttpRequest();

      // 2. Configure Request
      xhr.open('POST', 'https://app.nbpas.org/api_endpoints/get_application_sidebar.php');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.responseType = 'json';

      // 3. Send the request over the network
      xhr.send(user_data);

      // 4. This will be called after the response is received
      xhr.onload = function () {
          if (xhr.status != 200) {
              // analyze HTTP status of the response
              console.log(xhr.status);
              console.log(xhr.statusText);
          } else {
              // show the result
              // console.log(xhr.response);
              application_sidebar.innerHTML = xhr.response;
          }
      };
    }

    // Auto format date field
    document.body.addEventListener("keyup", function (event) {
        if (event.target.id == 'npi-number') {
            var npiField = event.target;
            npiField.value = npiField.value.replace(/[^0-9]/g, '');
        }

        if (event.target.id == 'hospital_search') {
            var search_value = event.target.value.toLowerCase();
            var hospital_list = document.querySelector("#hospital_list");

            var hospital_items = hospital_list.querySelectorAll(".hospital-item");
            hospital_items.forEach(item => {
                var item_search_string = item.getAttribute('data-search').toLowerCase();
                if (!item_search_string.includes(search_value)){
                    item.classList.add("d-none");
                } else {
                    item.classList.remove("d-none");
                }
            });

            var hospital_sections = hospital_list.querySelectorAll(".hospital-section");
            hospital_sections.forEach(hospital_section => {
                var hospital_items = hospital_section.querySelectorAll(".hospital-item");
                var item_search_string = hospital_section.getAttribute('data-search').toLowerCase();
                if (item_search_string.includes(search_value)) {
                    hospital_section.classList.remove("d-none");
                    hospital_items.forEach(item => {
                        item.classList.remove("d-none");
                    });
                } else {
                    var counter = 0;
                    hospital_items.forEach(item => {
                        if (item.classList.contains("d-none")) {
                            counter++;
                        }
                    });

                    if (hospital_items.length == counter){
                        hospital_section.classList.add("d-none");
                    }
                }
            });
        }

        if (event.target.id == 'faq_search') {
            var search_value = event.target.value.toLowerCase();
            var nbpas_faqs = document.querySelector("#nbpas_faqs");

            var faq_items = nbpas_faqs.querySelectorAll(".faq-item");
            faq_items.forEach(item => {
                var item_title_search = item.getAttribute('data-title').toLowerCase();
                var item_description_search = item.getAttribute('data-description').toLowerCase();
                if (!item_title_search.includes(search_value) && !item_description_search.includes(search_value)) {
                    item.classList.add("d-none");
                } else {
                    item.classList.remove("d-none");
                }
            });

            var faq_sections = nbpas_faqs.querySelectorAll(".faq-section");
            var hidden_sections = 0;
            faq_sections.forEach(faq_section => {
                var faq_items = faq_section.querySelectorAll(".faq-item");
                var item_search_string = faq_section.getAttribute('data-search').toLowerCase();
                if (item_search_string.includes(search_value)) {
                    faq_section.classList.remove("d-none");
                    faq_items.forEach(item => {
                        item.classList.remove("d-none");
                    });
                } else {
                    var counter = 0;
                    faq_items.forEach(item => {
                        if (item.classList.contains("d-none")) {
                            counter++;
                        }
                    });

                    if (faq_items.length == counter) {
                        faq_section.classList.add("d-none");
                        hidden_sections ++;
                    }
                }
            });

            var faq_search_no_match = document.querySelector("#faq_search_no_match");
            if (faq_sections.length == hidden_sections){
                faq_search_no_match.classList.remove("d-none");
            } else {
                faq_search_no_match.classList.add("d-none");
            }
        }

        if (event.target.id == 'search-hospital-address' || event.target.id == 'search-hospital-city') {
            if (typeof HospitalManager !== 'undefined' && HospitalManager.searchHospitalsDebounced) {
                HospitalManager.searchHospitalsDebounced();
            }
        }
    });

    // var productForms = document.querySelectorAll('.product-form');
    // productForms.forEach(function(form) {
    //   form.addEventListener('submit', function(event) {
    //     event.preventDefault();
        
    //     var formData = new FormData(form);
    //     // Log FormData values to the console
    //     for (var pair of formData.entries()) {
    //       console.log(pair[0] + ': ' + pair[1]);
    //     }
        
    //     fetch('/cart/add.js', {
    //       method: 'POST',
    //       body: formData,
    //       headers: {
    //         'Accept': 'application/json',
    //         'X-Requested-With': 'XMLHttpRequest'
    //       }
    //     })
    //     .then(response => response.json())
    //     .then(data => {
    //       console.log(data);
    //     })
    //     .catch(error => console.error('Error:', error));
    //   });
    // });
});
})();

// CME PORTAL FUNCTIONS (AWS)

function upload_files(files) {
    // Remove success and error messages
    // document.querySelector('#upload_success_alert').remove();
    // document.querySelector('#upload_error_alert').remove();

    // Disable file input
    var file_input = document.getElementById("files");
    file_input.disabled = true;

    var file_drop_area = document.getElementById('file_drop_area');
    file_drop_area.classList.add('disabled');

    var file_label = file_drop_area.querySelector('label[for="files"]');
    file_label.classList.remove('text-info', 'text-decoration-underline');
    file_label.classList.add('text-muted');
    file_label.innerHTML = 'Uploading Please Wait...';

    // Get user ID from URL
    let sitePathUrl = 'https://chympen-apps.com/nbpas_shopify/amazon/';
    let url_string = window.location.href;
    let url = new URL(url_string);
    let new_user_id = url.searchParams.get("user_id");
    // console.log(new_user_id);

    var overwrite_duplicate = document.querySelector('#overwrite_duplicate').checked;
    var is_admin = $.trim($("#is_admin").val());

    var notify_admin = false;
    var notify_user = false;
    if(is_admin == 'false'){
        notify_user = true;
        // Set up notification cookie
        let notifiaction_cookie = get_cookie("notifiaction_cookie");

        // If cookie is not set notify admin to true and set cookie
        if (notifiaction_cookie == "") {
            // Send notification
            notify_admin = true;
            set_cookie("notifiaction_cookie", "true", 1);
        }
    }

    // Create a formdata object and
    var data = new FormData();
    data.append('email', $("#txtEmail").val());
    data.append('username', $("#username").val());
    data.append('user_id', new_user_id);
    data.append('overwrite_duplicate', overwrite_duplicate);
    data.append('notify_admin', notify_admin);
    data.append('notify_user', notify_user);
    $.each(files, function (key, value) {
        data.append(key, value);
    });

    $.ajax({
        url: sitePathUrl + 's3_upload_functions.php?action=upload_file_s3',
        type: 'POST',
        data: data,
        cache: false,
        processData: false, // Don't process the files
        contentType: false, // Set content type to false as jQuery will tell the server its a query string request
        success: function (data, textStatus, jqXHR) {
            // console.log(data);
            // $("#spinnerAttachment").hide();
            var data = JSON.parse(data);
            // console.log(data);

            if (data.success.length > 0) {
                getFiles();

                // Show success message
                let success_alert = document.createElement('div');
                success_alert.setAttribute('id', 'upload_success_alert');
                success_alert.setAttribute('class', 'alert alert-success m-4 alert-dismissible fade show position-fixed bottom-0 end-0');
                success_alert.setAttribute('style', 'max-width: 400px;');
                success_alert.setAttribute('role', 'alert');

                let success_alert_p = document.createElement('p');
                success_alert_p.setAttribute('class', 'm-0');
                success_alert_p.innerHTML = 'The following file(s) where uploaded successfully:<br><br>';

                data.success.forEach(function (item, index) {
                    success_alert_p.innerHTML += item + '<br>';
                });
                success_alert.appendChild(success_alert_p);

                let success_alert_dismiss = document.createElement('button');
                success_alert_dismiss.setAttribute('type', 'button');
                success_alert_dismiss.setAttribute('class', 'btn-close');
                success_alert_dismiss.setAttribute('data-bs-dismiss', 'alert');
                success_alert_dismiss.setAttribute('aria-label', 'Close');
                success_alert.appendChild(success_alert_dismiss);

                document.querySelector('#MainContent .container').appendChild(success_alert);
            }

            if (data.error.length > 0) {
                // Show error message
                let error_alert = document.createElement('div');
                error_alert.setAttribute('id', 'upload_error_alert');
                error_alert.setAttribute('class', 'alert alert-danger m-4 alert-dismissible fade show position-fixed bottom-0 end-0');
                error_alert.setAttribute('style', 'max-width: 400px;');
                error_alert.setAttribute('role', 'alert');
               
                let error_alert_p = document.createElement('p');
                error_alert_p.setAttribute('class', 'm-0');
                error_alert_p.innerHTML = 'The following file(s) failed to upload:<br><br>';

                data.error.forEach(function (item, index) {
                    error_alert_p.innerHTML += item + '<br>';
                });
                error_alert.appendChild(error_alert_p);

                let error_alert_dismiss = document.createElement('button');
                error_alert_dismiss.setAttribute('type', 'button');
                error_alert_dismiss.setAttribute('class', 'btn-close');
                error_alert_dismiss.setAttribute('data-bs-dismiss', 'alert');
                error_alert_dismiss.setAttribute('aria-label', 'Close');
                error_alert.appendChild(error_alert_dismiss);

                document.querySelector('#MainContent .container').appendChild(error_alert);
            }

            // STOP LOADING SPINNER
            // $("#cmdRemoveAttachment").hide();
            // $("#divSelectedFiles").html("");

            // Enable file input
            file_drop_area.classList.remove('disabled');
            file_label.classList.add('text-info', 'text-decoration-underline');
            file_label.classList.remove('text-muted');
            file_label.innerHTML = 'or browse for files on your computer';
            file_input.disabled = false;
        },
        error: function (jqXHR, textStatus, errorThrown) {
            // Enable file input
            file_drop_area.classList.remove('disabled');
            file_label.classList.add('text-info', 'text-decoration-underline');
            file_label.classList.remove('text-muted');
            file_label.innerHTML = 'or browse for files on your computer';
            file_input.disabled = false;

            // Handle errors here
        }
    });
}

function getUserInfo() {
    $("#user_cme_info").empty();

    let sitePathUrl = 'https://chympen-apps.com/nbpas_shopify/amazon/';

    let url_string = window.location.href;
    let url = new URL(url_string);
    let new_user_id = url.searchParams.get("user_id");

    // Create a formdata object and
    var data = new FormData();
    data.append('user_id', new_user_id);

    $.ajax({
        url: sitePathUrl + 's3_upload_functions.php?action=get_user_info',
        type: 'POST',
        data: data,
        cache: false,
        processData: false, // Don't process the files
        contentType: false, // Set content type to false as jQuery will tell the server its a query string request
        success: function (data, textStatus, jqXHR) {
            var data = JSON.parse(data);
            // console.log(data);

            $("#user_cme_info").append(data.html);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            // Handle errors here

            // STOP LOADING SPINNER
        }
    });
}

function getFiles(name_filter = '', sort_type = '', sort_order = '') {
    $("#user_cme_files").empty();
    $("#spinner_files").show();

    let sitePathUrl = 'https://chympen-apps.com/nbpas_shopify/amazon/';

    let url_string = window.location.href;
    let url = new URL(url_string);
    let new_user_id = url.searchParams.get("user_id");
    let remove_file_success = url.searchParams.get("remove_file_success");

    let is_admin = $.trim($("#is_admin").val());

    // Create a formdata object and
    var data = new FormData();
    data.append('email', $("#txtEmail").val());
    data.append('username', $("#username").val());
    data.append('user_id', new_user_id);
    data.append('is_admin', is_admin);
    data.append('remove_file_success', remove_file_success);
    data.append('sort_type', sort_type);
    data.append('sort_order', sort_order);
    data.append('name_filter', name_filter);

    $.ajax({
        url: sitePathUrl + 's3_upload_functions.php?action=get_files_s3',
        type: 'POST',
        data: data,
        cache: false,
        processData: false, // Don't process the files
        contentType: false, // Set content type to false as jQuery will tell the server its a query string request
        success: function (data, textStatus, jqXHR) {
            $("#spinner_files").hide();

            var data = JSON.parse(data);
            // console.log(data);

            $("#user_cme_files").append(data.html);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            $("#spinner_files").hide();
            // Handle errors here

            // STOP LOADING SPINNER
        }
    });
}

function removeFiles(event, form) {
    event.preventDefault();

    var submit_btn = form.querySelector("button");
    loading(submit_btn);
    submit_btn.disabled = true;

    let url_string = window.location.href;
    let url = new URL(url_string);
    let new_user_id = url.searchParams.get("user_id");

    let sitePathUrl = 'https://chympen-apps.com/nbpas_shopify/amazon/';
    var file_checkboxes = document.querySelectorAll('#files_table tbody input[type="checkbox"]');
    var files_array = [];
    file_checkboxes.forEach(function (item, index) {
        if (item.checked) {
            files_array.push(item.value);
        }
    });

    // Create a formdata object
    var data = new FormData();
    data.append('files_array', JSON.stringify(files_array));
    data.append('user_id', new_user_id);

    $.ajax({
        url: sitePathUrl + 's3_upload_functions.php?action=remove_files_s3',
        type: 'POST',
        data: data,
        cache: false,
        processData: false, // Don't process the files
        contentType: false, // Set content type to false as jQuery will tell the server its a query string request
        success: function (data, textStatus, jqXHR) {
            var data = JSON.parse(data);
            // console.log(data);

            if (data.success) {
                getFiles();
            }

            var error_messages = document.querySelector('#error_messages');
            error_messages.innerHTML = data.success_msg_html;

            submit_btn.disabled = false;
            finished_loading(submit_btn, "Remove");
            $('#remove_file_modal').modal('hide');
        },
        error: function (jqXHR, textStatus, errorThrown) {
            // Handle errors here
        }
    });
}

function ft_bulk_action() {
    var file_checkboxes = document.querySelectorAll('#files_table tbody input[type="checkbox"]');
    var selected_items_counter = 0;
    file_checkboxes.forEach(function (item, index) {
        if (item.checked) {
            selected_items_counter++;
        }
    });

    if (selected_items_counter > 0) {
        var action = document.querySelector('#bulk_action');
        switch (action.value) {
            case 'remove':
                // show remove popup
                var remove_modal = document.querySelector('#remove_file_modal');
                var remove_modal_body = remove_modal.querySelector('.modal-body');

                remove_files_text = '<p>You are about to remove <b>' + selected_items_counter + '</b> file(s). Are you sure you want to remove the following files?<br><br>';
                file_checkboxes.forEach(function (item, index) {
                    if (item.checked) {
                        remove_files_text += '- ' + item.value.split('/')[1] + '<br>';
                    }
                });
                remove_files_text += '</p>';

                remove_modal_body.innerHTML = remove_files_text;
                $('#remove_file_modal').modal('show');
                break;
            case 'open':
                file_checkboxes.forEach(function (item, index) {
                    if (item.checked) {
                        window.open('https://nbpascme.s3.amazonaws.com/' + item.value);
                    }
                });
                break;
            case 'download':
                var sitePathUrl = 'https://chympen-apps.com/nbpas_shopify/amazon/';

                var url_string = window.location.href;
                var url = new URL(url_string);
                var new_user_id = url.searchParams.get("user_id");

                var files = [];
                file_checkboxes.forEach(function (item, index) {
                    if (item.checked) {
                        files.push(item.value);
                    }
                });

                window.location = sitePathUrl + 's3_upload_functions.php?action=download_bulk&email=' + $("#txtEmail").val() + '&user_id=' + new_user_id + '&files=' + files.toString();
                break;
            default:
                alert('You must select an action');
        }
    } else {
        alert('You must select at least one item');
    }
}

function download_individual_certification(opportunity_id) {
    window.location = 'https://app.nbpas.org/api_endpoints/download_individual_certificate.php?opportunity_id=' + opportunity_id;
}

function update_application_step(step, contactId = ''){
    var contactId = contactId || document.querySelector("#sf_contact_id").value;

    var user_data = {};
    user_data['contact_id'] = contactId;
    user_data['step'] = step;
    // console.log(user_data);

    user_data = JSON.stringify(user_data);
    var request = new Request('https://app.nbpas.org/api_endpoints/update_application_step.php', {
        method: 'POST',
        body: user_data,
        headers: {
            'Content-type': 'application/json'
        }
    });

    fetch(request)
    .then(function (response) {
        return response.json();
    })
    .then(function (data) {
        // console.log(data);
    });
}

function get_picklist_values(object, field_name, selector, object_id = ""){
    var user_data = {};
    user_data['object'] = object;
    user_data['field_name'] = field_name;
    user_data['object_id'] = object_id;
    // console.log(user_data);

    user_data = JSON.stringify(user_data);
    var request = new Request('https://app.nbpas.org/api_endpoints/get_picklist_values.php', {
        method: 'POST',
        body: user_data,
        headers: {
            'Content-type': 'application/json'
        }
    });

    fetch(request)
    .then(function (response) {
        return response.json();
    })
    .then(function (data) {
        // console.log(data);
        selector.innerHTML = data;
    });
}

function phone_input_change(element){
    element.value = element.value.replace(/[^0-9-+()]/g, '');
}

function getNumbersFromString(string){
    string = string.replace(/[^0-9]/g, '');
    return string;
}

function phone_input_int_change(element){
    element.value = element.value.replace(/[^0-9]/g, '');
}

function phoneInputValidation(value){
    var result = true;
    if(value.length > 11 || value.length < 10){
      result = false;
    }
    
    return result;
}

function validateDateOfBirth(month, day, year) {
  if (!month && !day && !year) {
    return true;
  }

  if (!month || !day || !year) {
    return false;
  }
  
  return true;
}

function format_phone(value){
    var output = value;

    if(value){
      value = value.replace(/[^0-9]/g, '');
  
      if(value.length > 9){
        if(value.length == 11){
          value = value.slice(1);
        }
        value = value.slice(0, 10);
        output = value.slice(0, 3) + "-" + value.slice(3, 6) + "-" + value.slice(6, 10);
      }
    }
  
    return output;
}

// function select_hospital_address(element){
//   const hospitalData = {
//     id: element.getAttribute("data-hospital-id"),
//     name: element.getAttribute("data-name"),
//     street: element.getAttribute("data-street"),
//     city: element.getAttribute("data-city"),
//     state: element.getAttribute("data-state"),
//     zipCode: element.getAttribute("data-zip")
//   };

//   // Save affiliated hospital in salesforce
//   await HospitalManager.add(hospitalData);
// }

function show_hospital_name_field(){
  var hospitalOtherCol = document.querySelector("#hospital-other-col");
  hospitalOtherCol.classList.remove("d-none");

  var hospitalSearchColumn = document.querySelector("#hospital-search-column");
  hospitalSearchColumn.classList.add("d-none");

//   document.querySelector("#hospital-id").value = '';
  document.querySelector("#search-hospital-address").value = '';
  document.querySelector("#search-hospital-city").value = '';
  document.querySelector("#search-hospital-state").value = '';

//   document.querySelector("#hospital-address").innerHTML = '';
  document.querySelector("#search-hospital-results").innerHTML = '';

  hospitalOtherCol.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

function showHospitalSearch(){
  var hospitalOtherCol = document.querySelector("#hospital-other-col");
  hospitalOtherCol.classList.add("d-none");

  var hospitalSearchColumn = document.querySelector("#hospital-search-column");
  hospitalSearchColumn.classList.remove("d-none");

  document.querySelector("#hospital-name").value = '';
  document.querySelector("#hospital-street").value = '';
  document.querySelector("#hospital-city").value = '';
  document.querySelector("#hospital-state").value = '';
  document.querySelector("#hospital-zip").value = '';

  hospitalSearchColumn.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

function get_cookie(name) {
    var cookies = document.cookie.split(';');
    // name = name.toLowerCase().replace(/ /g, '_');  // Transform the name in the same way

    for(var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var cookieTrimmed = cookie.trim();  // remove leading/trailing whitespace
        
        if (cookieTrimmed.indexOf(name + '=') === 0) {
            return cookieTrimmed.substring((name + '=').length, cookieTrimmed.length);
        }
    }

    return null;
}

function set_cookie(name, value, updateExisting = false) {
    // Transform the name
    name = name.toLowerCase().replace(/ /g, '_');

    // Check if the cookie exists
    var existingValue = get_cookie(name);
    if (existingValue === null || updateExisting) {
        // Cookie doesn't exist, or updateExisting is true, so set the cookie
        document.cookie = name + "=" + value + ";path=/";
    }
}

function get_all_cookies() {
    var cookies = document.cookie.split(';');
    var cookieObject = {};

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var parts = cookie.split('=');
        var name = parts[0].trim();
        var value = parts[1] ? decodeURIComponent(parts[1].trim()) : "";

        cookieObject[name] = value;
    }

    return cookieObject;
}

function delete_cookie(name) {
    // Set the expiration date to a date in the past (1st January 1970)
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

function getCheckboxValues(form, name) {
    const checkboxes = form.querySelectorAll('input[type="checkbox"][name="' + name + '"]:checked');
    const values = [];

    checkboxes.forEach(checkbox => {
        values.push(checkbox.value);
    });

    return values;
}

function googleAutocompleteInit() {
  var searchMailingAddress = document.getElementById("search-mailing-address");
  var autocomplete = new google.maps.places.Autocomplete(searchMailingAddress);

  autocomplete.addListener("place_changed", () => {
    var place = autocomplete.getPlace();
    console.log(place);
    var addressComponents = place.address_components;

    var mailingStreet = document.getElementById("mailing-street");
    var mailingCity = document.getElementById("mailing-city");
    var mailingState = document.getElementById("mailing-state");
    var mailingStateInt = document.getElementById("mailing-state-int");
    var mailingZip = document.getElementById("mailing-zip");
    var mailingZipInt = document.getElementById("mailing-zip-int");
    var mailingCountry = document.getElementById("mailing-country");

    var streetNumber = "";
    var route = "";
    var locality = "";
    var administrativeAreaLevel1 = "";
    var postalCode = "";
    var country = "";
    
    for (let i = 0; i < addressComponents.length; i++) {
      let component = addressComponents[i];
      
      if(component.types.includes("street_number")){
        streetNumber = component.long_name;
      }

      if(component.types.includes("route")){
        route = component.long_name;
      }

      if(component.types[0].includes("locality")){
        locality = component.long_name;
      }

      if(component.types.includes("administrative_area_level_1")){
        administrativeAreaLevel1 = component.short_name;
      }

      if(component.types.includes("postal_code")){
        postalCode = component.long_name;
      }

      if(component.types.includes("country")){
        country = component.long_name;
      }
    }

    if(streetNumber != ""){
      mailingStreet.value = streetNumber + " " + route;
    } else {
      mailingStreet.value = route;
    }

    mailingCity.value = locality;

    if(country != "United States"){
      mailingStateInt.classList.remove("d-none");
      mailingZipInt.classList.remove("d-none");
      document.querySelector("#mobile-phone-int").classList.remove("d-none");
      document.querySelector("#business-phone-int").classList.remove("d-none");

      mailingState.classList.add("d-none");
      mailingZip.classList.add("d-none");
      document.querySelector("#mobile-phone").classList.add("d-none");
      document.querySelector("#business-phone").classList.add("d-none");

      mailingStateInt.value = administrativeAreaLevel1;
      mailingZipInt.value = postalCode;
    } else {
      mailingStateInt.classList.add("d-none");
      mailingZipInt.classList.add("d-none");
      document.querySelector("#mobile-phone-int").classList.add("d-none");
      document.querySelector("#business-phone-int").classList.add("d-none");

      mailingState.classList.remove("d-none");
      mailingZip.classList.remove("d-none");
      document.querySelector("#mobile-phone").classList.remove("d-none");
      document.querySelector("#business-phone").classList.remove("d-none");

      mailingState.value = administrativeAreaLevel1;
      mailingZip.value = postalCode;
    }

    mailingCountry.value = country;
  });
}

function uploadMilitaryEvidence(event) {
    event.preventDefault();
    var form = event.target;

    var submitButton = form.querySelector('button[type=submit]');
    submitButtonLabel = submitButton.innerHTML;
    loading(submitButton);
    submitButton.disabled = true;

    // Remove any current error messages
    var errorAlert = document.querySelector('#upload-me-error-alert');
    errorAlert.classList.remove('show');
    errorAlert.classList.add('d-none');

    var successAlert = document.querySelector('#upload-me-success-alert');
    successAlert.classList.remove('show');
    successAlert.classList.add('d-none');
  
    var formData = new FormData(form);

    var request = new Request('https://app.nbpas.org/api_endpoints/uploadMilitaryEvidence.php', {
        method: 'POST',
        body: formData
    });

    fetch(request)
    .then(function(response) {
        return response.json();
    })
    .then(function(data) {
        // console.log(data);
        if (data.success) {
          successAlert.classList.add('show');
          successAlert.classList.remove('d-none');
          form.remove();
        } else {
          errorAlert.innerHTML = '';
          if(data.message) {
            errorAlert.innerHTML = data.message;
          } else {
            errorAlert.innerHTML = 'An error has ocurred. Please try again later.';
          }

          errorAlert.classList.add('show');
          errorAlert.classList.remove('d-none');
        }

        submitButton.disabled = false;
        finished_loading(submitButton, submitButtonLabel);
    });
}

function militaryEvidenceCheck(contactId) {
  var militrayEvidence = document.querySelector('#military-evidence-container');
  if(militrayEvidence){
      var formData = new FormData();
      formData.append('contact-id', contactId);

      var request = new Request('https://app.nbpas.org/militaryEvidenceCheck.php', {
          method: 'POST',
          body: formData
      });

      fetch(request)
      .then(function(response) {
          return response.json();
      })
      .then(function(data) {
          // console.log(data);
          if (data.success && data.display) {
            militrayEvidence.innerHTML = data.militaryEvidenceInput;
            document.querySelector('#military-evidence-alert').classList.remove('d-none');
          }
      });
  }
}

function payCharges(event) {
    event.preventDefault();
    const form = event.target;

    const formData = new FormData(form);
    let checkoutUrl = formData.get('checkout-url');

    setTimeout(function () {
        window.location.replace(checkoutUrl);
    }, 2000);
}

function formatDate(date) {
  let mm = date.getMonth() + 1; // getMonth() is zero-based
  let dd = date.getDate();
  let yyyy = date.getFullYear();

  // Add leading zero if necessary
  if (mm < 10) mm = '0' + mm;
  if (dd < 10) dd = '0' + dd;

  return mm + '-' + dd + '-' + yyyy;
}